import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import PhoneInput from 'react-phone-number-input';
import Select from 'react-select';
import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css';
import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from './../../../UseToken';
import Loader from '../../Loader/Loader';
import Swal from 'sweetalert2'
import moment from 'moment-timezone';
import Hosts from '../../../Hosts';
import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	obter_cidades_por_distrito,
	obter_freguesias_por_cidade,
	obter_paises_em_pt,
	obter_distritos_pt,
	pattern_vat,
	pattern_email,
	passwordHash,
	translate,
	handle_compressed_image_upload,
	repo_img_link,
	set_language
} from '../../../Utils';

import { language } from './Language';
import { color } from '../../WEBContent/Color';

const modalStyles = {
	modalOverlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		backgroundColor: color.corShadow.rgba2,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 1000,
	},
	modalContent: {
		backgroundColor: color.cor3.hexa,
		padding: '20px',
		borderRadius: '10px',
		width: '600px',
		maxWidth: '90%',
		textAlign: 'center',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		position: 'relative',
		overflow: 'hidden',
	},
	taskListContainer: {
		flex: 1,
		width: '100%',
		padding: '10px 15px',
		textAlign: 'start',
	},
	buttonContainer: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		marginTop: '15px',
	},
	closeButton: {
		padding: '10px 20px',
		border: 'none',
		borderRadius: '5px',
		cursor: 'pointer',
		backgroundColor: color.cor1.hexa,
		fontSize: '16px',
	},
};

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);
	const clubes = useRef(null);
	const modalidades = useRef(null)
	const competicoes_clube = useRef(null)
	const dirigentes_clube = useRef(null)
	const modal_add_dirigente_clube = useRef(null)
	const modal_is_edit = useRef(null)
	const modal_is_edit_order = useRef(null)
	const nota_de_encomenda = useRef(null)
	const fdi_iban = useRef();
	const competicao_el = useRef(null)
	const competicao_jogos = useRef(null)

	const temporada = useRef();
	const pay_fee_available = useRef();

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);
	const [lang_id, set_lang_id] = useState('1');
	const [is_password, set_is_password] = useState(false)
	const [new_password, set_new_password] = useState('')
	const [confirm_password, set_confirm_password] = useState('')
	const [competicoes, setCompeticoes] = useState([])
	const [, set_is_input_disabled] = useState(true);
	const [is_edit, set_is_edit] = useState(false)
	const [entities, setEntities] = useState([]);
	const [showAssociarModal, setShowAssociarModal] = useState(false);
	const [associarSearch, setAssociarSearch] = useState('');
	const [associarResults, setAssociarResults] = useState([]);
	const [associarLoading, setAssociarLoading] = useState(false);
	const [selectedEntityToAssociate, setSelectedEntityToAssociate] = useState(null);

	const [showAtletasCompeticaoModal, setShowAtletasCompeticaoModal] = useState(false);
	const [selectedCompeticaoAtletas, setSelectedCompeticaoAtletas] = useState(null);
	// ids dos atletas adicionados à tabela mas ainda não gravados na API
	const [atletasPendentes, setAtletasPendentes] = useState([]);

	const [showConvocatoriaDetalhesModal, setShowConvocatoriaDetalhesModal] = useState(false);
	const [selectedConvocatoria, setSelectedConvocatoria] = useState(null);
	const [novaPessoaConvocatoria, setNovaPessoaConvocatoria] = useState({});

	const [files_image, set_files_image] = useState([]);
	const [image_base64, set_image_base64] = useState([]);
	const [photo_base64, set_photo_base64] = useState('');
	const [img_loader, set_img_loader] = useState([])

	const [files_doc, set_files_doc] = useState([]);

	const [countries, set_countries] = useState([])
	const [districts, set_districts] = useState([])
	const [cities, set_cities] = useState([])
	const [villages, set_villages] = useState([])
	const [show_district_city_village, set_show_district_city_village] = useState('')

	const fetch_id_info = async (id_serch) => {

		if(id_serch !== '') {
			return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
				.then(res => {

					if (res.data[0].profile.name === 'Administrador') {
						if (getTokenInfo().profile === 'Administrador') {
							set_dados(dados.current = ensure_address(res.data[0]));
						} else {
							setRedirect(true);
						}
					}
					else {
						set_dados(dados.current = ensure_address(res.data[0]));

						if(Array.isArray(res.data[0].contacts) && res.data[0].contacts.length > 0 && Array.isArray(res.data[0].contacts[0].person_responsables) && res.data[0].contacts[0].person_responsables.length > 0 && res.data[0].contacts[0].person_responsables[0].name !== '') {
							set_dados(dirigentes_clube.current = res.data[0].contacts[0].person_responsables)
							console.log('dirigentes_clube.current', dirigentes_clube.current)
						}

					}
					setRefresh(r => r + 1)

				})
				.catch(error => console.log(error))
		}
		else {
			return set_dados(dados.current = ensure_address({}))
		}

	}

	const ensure_address = (d) => {
		if (!Array.isArray(d.addresses) || d.addresses.length === 0) {
			d.addresses = [{}]
		}
		d.addresses[0] = {
			localidade: '',
			postal_code: '',
			village: '',
			city: '',
			region: '',
			country: '',
			address_detail: '',
			...d.addresses[0]
		}
		return d
	}

	const clean_data = () => {
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		set_dados(dados.current.info.office = getTokenInfo().office)
		set_dados(dados.current = ensure_address(dados.current))
	}

	useEffect(() => {

		(async () => {

			clean_data();
			
			set_dados(clubes.current = [])
			set_dados(modalidades.current = [])
			set_dados(competicoes_clube.current = [])
			set_dados(dirigentes_clube.current = [])
			set_dados(modal_add_dirigente_clube.current = {})
			set_dados(modal_is_edit.current = false)
			set_dados(modal_is_edit_order.current = -1)

			set_dados(competicao_el.current = {})
			set_dados(competicao_jogos.current = [])

			await getTemporadaAtiva();

			set_lang(localStorage.getItem('lang'))

			obter_paises_em_pt(set_countries)

			if (getTokenInfo().profile !== '' && getTokenInfo().profile === 'Clube') {

				console.log('11111')
			
				try {
					set_is_input_disabled(false)

					set_is_edit(true)

					set_show_delete_button(true)

					let id = getTokenInfo().id

					await fetch_id_info(id).then(() => {
						
						setLoading(false)

						if (dados.current.addresses?.[0]?.country === 'Portugal') {
							obter_distritos_pt(set_districts)
							obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)
							obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
						}
						else if (dados.current.addresses?.[0]?.country) {
							set_show_district_city_village('d-none')
						}
					})
					return

				} catch {
					clean_data()

					setLoading(false);

					setRedirect(false);
					return
				}

			}
			else {

				console.log('2222')

				try {

					let test = props.location.state.operation;

					console.log('## test', test)


					if (test === 'edit') {
						set_is_input_disabled(false)

						set_is_edit(true)

						set_show_delete_button(true)

						let id = props.location.state.item['id']
						console.log('### id', id)

						await fetch_id_info(props.location.state.item['id']).then(() => {
							
							setLoading(false)

							if (dados.current.addresses?.[0]?.country === 'Portugal') {
								obter_distritos_pt(set_districts)
								obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)
								obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
							}
							else if (dados.current.addresses?.[0]?.country) {
								set_show_district_city_village('d-none')
							}
						})
						return
					}

				} catch {
					clean_data()

					setLoading(false);

					setRedirect(false);
					return
				}

			}

			return () => {
				clean_data()
			}
		
		})()

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					if (is_password) {
						let password = new_password;
						dados.current.info.password = passwordHash(password);
					}

					reqPUT(api_crud_route, dados.current)
						.then(() => {
							set_new_password('')
							set_confirm_password('')

							files_image.forEach(async (el_image) => {
								if (el_image !== null) {
									if (el_image.files.length > 0) {
										await uploadFilesImage(el_image.files, el_image.order, 'photo', el_image.langid, el_image.lang)
									}
								}
							})
							set_files_image([])
							set_image_base64([])

							files_doc.forEach(async (el_doc) => {
								if (el_doc !== null) {
									await uploadFilesDoc(el_doc.files, el_doc.field)
								}
							})
							set_files_doc([])

							// props.history.push(endpoints.list)
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})

		} else {

			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					if (is_password) {
						let password = new_password;
						dados.current.info.password = passwordHash(password);
					}

					reqPOST(api_crud_route, dados.current)
						.then((res) => {
							if(parseInt(res.status) === 200) {
								console.log('POST clube - resposta', res)

								const novo_id = res?.data?.id ?? res?.data?.[0]?.id ?? (typeof res?.data === 'string' ? res.data : undefined)
								if (novo_id) {
									set_dados(dados.current.id = novo_id)
								} else {
									console.warn('Não consegui encontrar o id do clube na resposta do POST — o upload do logo/documentos pode falhar.')
								}

								set_new_password('')
								set_confirm_password('')

								files_image.forEach(async (el_image) => {
									if (el_image !== null) {
										if (el_image.files.length > 0) {
											await uploadFilesImage(el_image.files, el_image.order, 'photo', el_image.langid, el_image.lang)
										}
									}
								})
								set_files_image([])
								set_image_base64([])

								files_doc.forEach(async (el_doc) => {
									if (el_doc !== null) {
										await uploadFilesDoc(el_doc.files, el_doc.field)
									}
								})
								set_files_doc([])

								props.history.push(endpoints.list)
							}
							else {
								Swal.fire(language[lang].insert_error, '', 'info')
							}
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})

		}
	}

	const handleSubmitConfig = async e => {
		e.preventDefault();

		if (is_edit === true) {

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {
						reqPUT(api_crud_route, dados.current)
							.then(() => { props.history.push(endpoints.list) })
							.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
					}
				})

		} else {

			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {
						let password = dados.current.info.password;
						dados.current.info.password = passwordHash(password);

						reqPOST(api_crud_route, dados.current)
							.then(() => { props.history.push(endpoints.list) })
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					}
				})

		}
	}

	const handleSubmitPassword = async e => {
		e.preventDefault();

		Swal.fire({
			title: language[lang].edit_title,
			text: language[lang].edit_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqPUT(api_crud_route, dados.current)
						.then(() => { props.history.push(endpoints.list) })
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
	}

	function apagar() {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqDELETE(api_crud_route + '/', { id: dados.current.id })
						.then(res => {
							props.history.push(endpoints.list);
						})
						.catch(() => Swal.fire(language[lang].delete_error, '', 'info'))
				}
			})
	};

	const load_entity = async (field, value, entity) => {
		let search_string = ''

		if (entity === '') {
			search_string = `${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`
		}
		else
			search_string = `${api_crud_base}/entities/list/${getTokenInfo().companycode}/${entity}`

		reqGET(search_string)
			.then(res => {

				let ja_existe = false
				res.data.forEach((k) => {
					if (k[field] === value && value !== '') {

						ja_existe = true
					}
				})

				if (ja_existe === false) {
					set_is_input_disabled(true)

					if (field === 'username') {
						set_is_input_disabled(false)
					}
					return

				} else {

					Swal.fire({
						title: language[lang].warning_title,
						text: language[lang].warning_text,
						icon: 'warning',
						showCancelButton: false,
						confirmButtonColor: '#0095e8',
						cancelButtonColor: '#d9214e',
						confirmButtonText: language[lang].warning_confirm,
						cancelButtonText: language[lang].warning_cancel
					})
						.then((result) => {
							if (result.isConfirmed) {
								set_is_input_disabled(true)
								document.getElementById('username').style.color = 'red';
							}
						})

				}
			})
	}

	const uploadFile = async (file, field) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'content')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/content/');

		console.log('uploadFile - a enviar', { field, id: dados.current.id, file_name: file.name })

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				console.log('uploadFile - resposta reqFILE', res)

				var today_file = new Date()

				let i = Date.now()

				let x = {
					id: i,
					info: {
						companycode: getTokenInfo().companycode,
						type: res.data.mimetype,
						link: res.data.path + '/' + res.data.name,
						size: res.data.size,
						date: today_file
					},
					content: {
						name: file.name,
						description: '',
						lang: []
					}
				}

				const file_meta = {
					name: file.name,
					type: file.type,
					size: file.size,
					path: res.data.path,
					source_name: res.data.name,
					link: res.data.path + '' + res.data.name,
				};

				set_dados(dados.current.info[field] = [file_meta]);

				console.log('uploadFile - PUT a gravar', field, dados.current.info[field])

				reqPUT(api_crud_route, dados.current)
					.then((res_put) => {
						console.log('uploadFile - resposta PUT', res_put)
					})
					.catch((err_put) => {
						console.log('uploadFile - erro PUT', err_put)
						Swal.fire(language[lang].edit_error, '', 'info')
					})

				reqPOST(`${api_crud_base}/multimedia`, x)
					.then(() => {

						let y2 = img_loader
						y2.pop()
						set_img_loader(y2)
						setRefresh(i)

					})
					.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))

				return true

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const change_lang = (l) => {
		set_language(l)
		set_lang(l)
	}

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		if(name === 'email') {
			set_dados(dados.current.contacts[0][name] = value)
		}

		set_dados(dados.current.info[name] = value)
	}

	const handle_change_login = (e) => {
		const { value } = e.target;

		load_entity('username', value, '')
	}

	const handle_change_addresses = (e, addresses_index = 0) => {
		const { name, value } = e.target;
		set_dados(dados.current.addresses[addresses_index][name] = value)
	}

	const change_country = (e) => {

		set_cities([])
		set_villages([])

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = '');

		if (e.value === 'Portugal') {

			set_show_district_city_village('')

			if (districts.length === 0) {
				obter_distritos_pt(set_districts)
			}
		}
		else {
			set_show_district_city_village('d-none')
		}

		set_dados(dados.current.addresses[0].country = e.value);
	}

	const change_district = (e) => {

		set_cities([])
		set_villages([])

		obter_cidades_por_distrito(e.value, set_cities)

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = e.value);
	}

	const change_city = (e) => {
		set_villages([])
		obter_freguesias_por_cidade(e.value, set_villages)
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].city = e.value);
	}

	const change_village = (e) => {
		set_dados(dados.current.addresses[0].village = e.value);
	}

	const handle_change_info_new_password = (e) => {
		const { value } = e.target;

		set_new_password(value)
	}

	const handle_change_password = (e) => {
		const { value } = e.target;

		if (new_password === value) {
			set_is_password(true)
		}
		else {
			Swal.fire(language[lang].password_text, '', 'info')
			set_is_password(false)
		}
	}

	const handleSingleCheckDarkmode = (e) => {
		if (dados.current.info['darkmode'] === true) {
			set_dados(dados.current.info['darkmode'] = false)
		}
		else {
			set_dados(dados.current.info['darkmode'] = true)
		}
	}

	const onChangeHandlerFilesImage = async (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);
		let files_img_aux = image_base64

		let k = 0
		for await (let v of filesArray) {
			if ((v.type.includes('image/')) && (v.size < 10485760)) {

				await handle_compressed_image_upload(v, (valor) => storedFiles.push(valor))

				await convertBase64(v)
					.then((base64) => {

						if (files_img_aux[order] === undefined)
							files_img_aux[order] = []
						if (files_img_aux[order][langid] === undefined)
							files_img_aux[order][langid] = []

						files_img_aux[order][langid].push({ id: '1', langid: langid, name: v.name.split('.')[0] + '.webp', link: base64 })
						set_image_base64(files_img_aux)
						set_photo_base64(base64)
						setRefresh(refresh + Math.random())
					})


				if (filesArray.length === (k + 1)) {
					setRefresh(refresh + parseInt(v.size) + k)
				}

			}
			else {
				Swal.fire(language[lang].upload_image_error + v.name, '', 'info')
			}

			k++
		}

		let files_aux = files_image
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_image(files_aux)

	}

	const convertBase64 = async (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);

			fileReader.onload = () => {
				resolve(fileReader.result);
			};

			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};

	const handleFileRemove = () => {

		set_dados(dados.current.info.logo = [])
		set_photo_base64('')
		set_image_base64([])

	};

	const uploadFilesImage = async (files, order, type, langid, lang) => {

		let aux = []
		files.forEach(async (element) => {
			if (element.type.includes('image/')) {
				aux.push(element)

				let y = img_loader
				y.push('img')
				set_img_loader(y)

				await uploadFile(element, 'logo')
					.then(() => {
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const onChangeHandlerFilesDoc = (e) => {
		const { files, dataset } = e.target;
		const { field } = dataset;

		let filesArray = Array.prototype.slice.call(files);
		let storedFiles = [];

		filesArray.forEach((v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				set_dados(dados.current.info[field] = [{
					name: v.name,
					type: v.type,
					size: v.size,
					link: '',
				}])
			}
			else {
				Swal.fire((language[lang].upload_file_error ?? 'Formato do ficheiro incorrecto: ') + v.name, '', 'info')
			}
		});

		if (storedFiles.length > 0) {
			let files_aux = files_doc
			files_aux.push({ files: storedFiles, field: field })
			set_files_doc(files_aux)
			setRefresh(refresh + 1)
		}
	}

	const uploadFilesDoc = async (files, field) => {
		files.forEach((element) => {
			if (element.type === 'application/pdf') {
				uploadFile(element, field)
					.then(() => {
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const handleDocRemove = (field) => {
		set_dados(dados.current.info[field] = [])
		setRefresh(refresh + 1)
	};

	const edit_element_tree_doc = (field, e) => {
		const { value } = e.target;
		if (Array.isArray(dados.current.info[field]) && dados.current.info[field][0]) {
			dados.current.info[field][0].name = value
			set_dados(dados.current.info[field])
			setRefresh(refresh + 1)
		}
	}

	const open_link = (url) => {
		if (url) window.open(url, '_blank');
	}

	const copy_clipboard = (url) => {
		if (!url) return
		navigator.clipboard.writeText(url)

		Swal.fire({
			icon: '',
			title: '',
			text: 'Copiado',
			showConfirmButton: false,
			timer: 1000
		})
	}

	const modalidades_lista = [
		{ value: 'ski_de_fundo', label: 'Esqui de Fundo' },
		{ value: 'curling', label: 'Curling' },
		{ value: 'ski_alpino', label: 'Esqui Alpino' },
		{ value: 'bobsled', label: 'Bobsled' },
		{ value: 'hoquei_no_gelo', label: 'Hóquei no Gelo' },
		{ value: 'luge', label: 'Luge' },
		{ value: 'snowboard', label: 'Snowboard' },
		{ value: 'skeleton', label: 'Skeleton' },
		{ value: 'patinagem_artistica', label: 'Patinagem Artística' },
		{ value: 'patinagem_de_velocidade', label: 'Patinagem de Velocidade' },
		{ value: 'ski_freestyle', label: 'Esqui Freestyle' },
		{ value: 'biatlo', label: 'Biatlo' },
	];

	const tipo_competicao_lista = [
		{ value: 'campeonato_nacional', label: 'Campeonato Nacional' },
		{ value: 'campeonato_regional', label: 'Campeonato Regional' },
		{ value: 'taca', label: 'Taça' },
		{ value: 'torneio', label: 'Torneio' },
		{ value: 'internacional', label: 'Internacional' },
		{ value: 'outro', label: 'Outro' },
	];

	const get_label = (lista, value) => lista.find(o => o.value === value)?.label ?? value ?? '-';

	const change_modalidades = (selected) => {
		set_dados(dados.current.info.modalidades = selected || []);
	};

	const change_presidente = (e) => {
		const selectedId = e.target.value;
		const selected = board_members.find(el => String(el.id) === String(selectedId));

		set_dados(dados.current.info.presidente = selected
			? { id: selected.id, label: selected.info?.name ?? '' }
			: { id: '', label: '' });
	};

	const getTemporadaAtiva = async () => {

		let temporada_aux = await reqGET(`${Hosts.SIMCore_API}/intranet/components/type/${getTokenInfo().companycode}/temporada`)
		if(Array.isArray(temporada_aux.data)) {
			let t_aux = temporada_aux.data.find(e => e.info.active)
			set_dados(temporada.current = t_aux);
		}

	};

	const getAnoEpocaAtual = () => {
		if(temporada.current !== undefined) {
			return temporada.current.info.name
		}
		else {
			// getAnoEpocaAtual()
		}



		// const hoje = new Date();
		// const anoAtual = hoje.getFullYear();
		// const mesAtual = hoje.getMonth();
		// return mesAtual >= 6 ? anoAtual : anoAtual - 1;
	};

	// const epoca_atual = `${getAnoEpocaAtual()}/${getAnoEpocaAtual() + 1}`;
	const epoca_atual = `${getAnoEpocaAtual()}`;

	// Normaliza o formato da época para "AAAA/AAAA" (ex.: "2026/27" -> "2026/2027"),
	// para que a mesma época não fique gravada sob chaves diferentes consoante
	// o sítio que a escreveu.
	const normalizar_epoca = (epoca_str) => {
		if (!epoca_str) return epoca_str
		const partes = String(epoca_str).split('/')
		if (partes.length !== 2) return epoca_str
		let [inicio, fim] = partes.map(p => p.trim())
		if (fim.length === 2 && inicio.length === 4) {
			fim = inicio.slice(0, 2) + fim
		}
		return `${inicio}/${fim}`
	}

	let year = new Date().getFullYear();

	// ================= CÁLCULO DE ESCALÃO POR MODALIDADE =================
	// Um atleta pode praticar várias modalidades, e cada modalidade pode usar
	// uma tabela de escalões diferente (ex.: snowboard usa "U18_ROOKIE", não
	// "U18"). Estas tabelas/funções são as mesmas usadas no módulo das
	// Competições, para calcular corretamente o escalão de um atleta consoante
	// a modalidade em causa, em vez de assumir sempre um único escalão fixo.
	const ESCALOES_GERAL = [
		{ id: 'U10', label: 'U10', min: (parseInt(year) - 9), max: Infinity },
		{ id: 'U12', label: 'U12', min: (parseInt(year) - 11), max: (parseInt(year) - 10) },
		{ id: 'U14', label: 'U14', min: (parseInt(year) - 13), max: (parseInt(year) - 12) },
		{ id: 'U16', label: 'U16', min: (parseInt(year) - 15), max: (parseInt(year) - 14) },
		{ id: 'U18', label: 'U18', min: (parseInt(year) - 17), max: (parseInt(year) - 16) },
		{ id: 'U21', label: 'U21', min: (parseInt(year) - 20), max: (parseInt(year) - 17) },
		{ id: 'SENIOR', label: 'Sénior', min: (parseInt(year) - 34), max: (parseInt(year) - 21) },
		{ id: 'M35', label: 'M35', min: (parseInt(year) - 54), max: (parseInt(year) - 35) },
		{ id: 'M55', label: 'M55', min: -Infinity, max: (parseInt(year) - 55) },
	];

	const ESCALOES_SNOWBOARD = [
		{ id: 'U9', label: 'U9 (kids)', min: (parseInt(year) - 8), max: Infinity },
		{ id: 'U11', label: 'U11 (SuperGrom)', min: (parseInt(year) - 10), max: (parseInt(year) - 9) },
		{ id: 'U13', label: 'U13 (SuperGrom)', min: (parseInt(year) - 12), max: (parseInt(year) - 11) },
		{ id: 'U15', label: 'U15 (Grom)', min: (parseInt(year) - 14), max: (parseInt(year) - 13) },
		{ id: 'U18_ROOKIE', label: 'U18 (Rookie)', min: (parseInt(year) - 17), max: (parseInt(year) - 15) },
		{ id: 'ABSOLUTO', label: 'Absoluto', min: (parseInt(year) - 42), max: (parseInt(year) - 18) },
		{ id: 'M40', label: 'M40 (Master)', min: -Infinity, max: (parseInt(year) - 43) },
	];

	const anoNascimento = (birthday) => {
		if (!birthday) return null;
		const ano = parseInt(String(birthday).slice(0, 4), 10);
		return Number.isNaN(ano) ? null : ano;
	};

	const escalaoPorAno = (ano, tabela) => {
		if (ano === null) return '';
		const item = tabela.find(e => ano >= e.min && ano <= e.max);
		return item ? item.id : '';
	};

	const idadeReferencia = (birthday, anoEpoca) => {
		if (!birthday) return null;
		const nascimento = new Date(birthday);
		const referencia = new Date(anoEpoca, 6, 1);
		let idade = referencia.getFullYear() - nascimento.getFullYear();
		const diffMes = referencia.getMonth() - nascimento.getMonth();
		if (diffMes < 0 || (diffMes === 0 && referencia.getDate() < nascimento.getDate())) idade--;
		return idade;
	};

	const escalaoPorIdade = (idade) => {
		if (idade === null) return '';
		if (idade >= 28) return 'ADULTOS';
		if (idade > 13 && idade <= 18) return 'JUNIORES';
		if (idade >= 8 && idade <= 13) return 'NOVATOS';
		if (idade >= 17) return 'SENIORES';
		if (idade >= 6) return 'PRE_INICIADO';
		return '';
	};

	const detectarGrupoModalidade = (modalidade_value) => {
		const v = (modalidade_value ?? '').toString().toLowerCase();
		if (v.includes('patinacao')) return 'patinagem';
		if (v.includes('snowboard')) return 'snowboard';
		return 'geral';
	};

	// Escalão de uma entidade, para uma dada modalidade (valor único)
	const calcular_escalao_para_modalidade = (entidade, modalidade_value) => {
		const birthday = entidade?.info?.birthday ?? entidade?.birthday
		const grupo = detectarGrupoModalidade(modalidade_value)
		const anoEpoca = getAnoEpocaAtual()

		if (grupo === 'patinagem') {
			return escalaoPorIdade(idadeReferencia(birthday, anoEpoca))
		}
		const tabela = grupo === 'snowboard' ? ESCALOES_SNOWBOARD : ESCALOES_GERAL
		return escalaoPorAno(anoNascimento(birthday), tabela)
	};

	const get_modalidades_entidade = (entidade) => {
		const mods = entidade?.info?.modalidades

		if (Array.isArray(mods) && mods.length > 0) return mods.map(m => {
			if(m?.value !== undefined) { 
				return m.value
			}
			else if(m?.id !== undefined) {
				return m.id
			}
			else {
				return []
			}
		})

		const singular = entidade?.info?.modalidade
		if (singular) return [singular]

		return []
	};

	const get_registo_valores = (registo, campo_plural, campo_singular) => {
		const plural = registo?.info?.[campo_plural]
		if (Array.isArray(plural) && plural.length > 0) return plural.map(m => (m.value ?? m))
		const singular = registo?.info?.[campo_singular]
		if (singular) return [singular]
		return []
	};

	const get_overlapping_modalidades = (entidade, modalidades_alvo) => {
		const mods_entidade = get_modalidades_entidade(entidade)

		if (!modalidades_alvo || modalidades_alvo.length === 0) return mods_entidade
		return mods_entidade.filter(m => modalidades_alvo.includes(m))
	};

	// A entidade pratica pelo menos uma das modalidades do registo?
	const entidade_pratica_modalidade = (entidade, modalidades_alvo) => {
		if (!modalidades_alvo || modalidades_alvo.length === 0) return true
		return get_overlapping_modalidades(entidade, modalidades_alvo).length > 0
	};

	// Escalão da entidade, calculado a partir da primeira modalidade em comum
	const calcular_escalao_entidade = (entidade, modalidades_alvo) => {
		const overlapping = get_overlapping_modalidades(entidade, modalidades_alvo)
		return calcular_escalao_para_modalidade(entidade, overlapping[0])
	};

	// A entidade está em algum dos escalões do registo, considerando todas as
	// modalidades em comum (cada modalidade pode implicar um escalão diferente)?
	const entidade_esta_no_escalao = (entidade, modalidades_alvo, escaloes_alvo) => {
		if (!escaloes_alvo || escaloes_alvo.length === 0) return true
		const overlapping = get_overlapping_modalidades(entidade, modalidades_alvo)
		if (overlapping.length === 0) return false
		return overlapping.some(m => escaloes_alvo.includes(calcular_escalao_para_modalidade(entidade, m)))
	};

	const order_array_data_jogo_asc = (array) => {
		return array.sort((a, b) => {
			return a.info.data_jogo.localeCompare(b.info.data_jogo, undefined, { numeric: false, sensitivity: 'base' })
		});
	}
	const order_array_hora_jogo_asc = (array) => {
		return array.sort((a, b) => {
			return a.info.hora_inicio.localeCompare(b.info.hora_inicio, undefined, { numeric: false, sensitivity: 'base' })
		});
	}

	const fetch_entities = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/special/${getTokenInfo().companycode}/*`);
			if(Array.isArray(res.data)) {
				let aAux = []
				res.data.forEach(el => {
					if(Array.isArray(el.info.inscricao)) {
						let aux = el.info.inscricao.find(el_2 => parseInt(el_2.temporada.id) === parseInt(temporada.current.id))
						// console.log('&&&&&&&&&&&& dados.current', dados.current)
						// console.log('&&&&&&&&&&&& aux', aux)
						if(aux?.timestamp !== undefined && ((aux?.clube?.id !== undefined && dados?.current?.id !== undefined) && parseInt(aux.clube.id) === parseInt(dados.current.id))) {
							// console.log('el', el)
							// console.log('el.info.name', el.info.name)
							aAux.push(el)
						}
					}
				})
				// console.log('///////////////////// aAux', aAux)

				setEntities(aAux)
			}
			else {
				setEntities([]);
			}

		} catch (error) {
			console.error("Erro ao buscar as entities:", error);
		}
	};

	const fetch_competitions = async () => {
		try {
			const res = await reqGET(`${api_crud_base}/intranet/components/type/${getTokenInfo().companycode}/competicoes`)

			if (res.data !== undefined && temporada.current !== undefined) {

				// console.log('|||||||||||||||temporada.current', temporada.current)
				let result = []
				let result_jogos = []
				// res.data.forEach(el => {
				for await (let el of res.data) {
					// console.log('el', el)
					// console.log('temporada.current', temporada.current)
					if(el?.info?.available !== undefined && el?.info?.available === true) {
						if(el?.info?.epoca?.id !== undefined && el?.info?.epoca?.id !== null && el.info.epoca.id === temporada.current.id) {

							result.push(el)

							console.log('### dados.current.id', dados.current.id)
							let res_2 = await reqGET(`${api_crud_base}/intranet/components/type/extra/${getTokenInfo().companycode}/jogos/competition/${el.id}`)
							if(Array.isArray(res_2.data)) {
								res_2.data.forEach(el_2 => {
									console.log('### el_2', el_2)
									if(parseInt(el_2?.info?.equipa_casa?.id) === parseInt(dados.current.id) || parseInt(el_2?.info?.equipa_visitante?.id) === parseInt(dados.current.id)) {
										result_jogos.push(el_2)
									}
								})
								
							}

						}
					}
				}
				// })
				// console.log('result', result)

				result_jogos = order_array_data_jogo_asc(result_jogos)
				result_jogos = order_array_hora_jogo_asc(result_jogos)

				setCompeticoes(result)
				set_dados(competicao_jogos.current = result_jogos)
				console.log('Lista de competições carregada com sucesso:', res.data)
			}
		} catch (error) {
			console.error('Erro ao carregar lista de competições:', error)
		}
	}

	const fetchAndDisplayData = async () => {
		await fetch_entities();
	};

	useEffect(() => {
		(async () => {
			await fetchAndDisplayData();
			await fetch_clubes()
			await fetch_competitions();
        })()
	}, [temporada.current]);

	const has_valid_entity_type = (e) => {
		const et = e?.entity_type;
		const etArr = Array.isArray(et) ? et.map(String) : (et !== undefined && et !== null && et !== '' ? [String(et)] : []);
		return etArr.includes('1') || etArr.includes('2');
	};

	const search_entities_to_associate = async (term) => {
		setAssociarLoading(true)
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/*`)
			const t = (term || '').toLowerCase()
			const filtered = (res.data || []).filter(e => {
				const nome = (e?.info?.name ?? e?.name ?? '').toLowerCase()
				return has_valid_entity_type(e) && (t === '' || nome.includes(t))
			})
			setAssociarResults(filtered)
		} catch (error) {
			console.error('Erro ao pesquisar entidades:', error)
		} finally {
			setAssociarLoading(false)
		}
	}

	useEffect(() => {
		if (showAssociarModal) {
			search_entities_to_associate(associarSearch)
		}
	}, [showAssociarModal])

	const handle_associar_search_change = (e) => {
		const value = e.target.value
		setAssociarSearch(value)
		search_entities_to_associate(value)
	}

	const handleCloseAssociarModal = () => {
		setShowAssociarModal(false)
		setSelectedEntityToAssociate(null)
		setAssociarSearch('')
	}

	const get_clubes_entidade = (entidade) => {
		const c = entidade?.info?.clube ?? entidade?.clube
		if (Array.isArray(c)) return c
		if (c && c.id) return [c]
		return []
	}

	const associar_entidade_ao_clube = (entidade) => {

		if (!dados.current?.id) {
			Swal.fire(language[lang].associar_precisa_gravar ?? 'Grave o clube primeiro para poder associar entidades', '', 'info')
			return
		}

		const nome_entidade = entidade?.info?.name ?? entidade?.name ?? ''
		const clubes_atuais = get_clubes_entidade(entidade)
		const ja_esta_neste_clube = clubes_atuais.some(c => String(c?.id ?? '') === String(dados.current.id))
		const outros_clubes = clubes_atuais.filter(c => String(c?.id ?? '') !== String(dados.current.id))

		console.log('Associar a entidade a um clube', { nome_entidade, clubes_atuais, ja_esta_neste_clube })

		if (ja_esta_neste_clube) {
			Swal.fire('', language[lang].associar_ja_neste_clube ?? 'Esta entidade já está associada a este clube', 'info')
			return
		}

		const texto_html = outros_clubes.length > 0
			? `${language[lang].associar_text_multi ?? 'A entidade'} <b>${nome_entidade}</b> ${language[lang].associar_text_multi_2 ?? 'já está associada a'} <b>${outros_clubes.map(c => c.name ?? c.label).join(', ')}</b>. ${language[lang].associar_text_multi_3 ?? 'Ao confirmar, fica também associada a este clube (mantém os restantes).'}`
			: `${language[lang].associar_text ?? 'Confirma associar'} <b>${nome_entidade}</b> ${language[lang].associar_text_2 ?? 'a este clube?'}`

		Swal.fire({
			title: language[lang].associar_title ?? 'Associar entidade ao clube',
			html: texto_html,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].associar_confirm ?? 'Associar',
			cancelButtonText: language[lang].associar_cancel ?? 'Cancelar'
		})
			.then(async (result) => {
				if (result.isConfirmed) {
					try {
						const full = await reqGET(`${Hosts.SIMCore_API}/entities/${getTokenInfo().companycode}/${entidade.id}`)
						const entidade_completa = Array.isArray(full?.data) ? full.data[0] : (full?.data ?? entidade)

						let entidade_atualizada = JSON.parse(JSON.stringify(entidade_completa))
						if (entidade_atualizada.info === undefined) entidade_atualizada.info = {}

						const clubes_existentes = get_clubes_entidade(entidade_atualizada)
						entidade_atualizada.info.clube = [
							...clubes_existentes,
							{ id: dados.current.id, name: dados.current.info.name }
						]

						console.log('PUT entities - payload enviado', entidade_atualizada)

						reqPUT(`${Hosts.SIMCore_API}/entities`, entidade_atualizada)
							.then((res) => {
								console.log('PUT entities - resposta', res)
								Swal.fire('', language[lang].associar_success ?? 'Entidade associada com sucesso', 'success')
								handleCloseAssociarModal()
								fetch_entities()
							})
							.catch((err) => {
								console.log('PUT entities - erro', err)
								Swal.fire(language[lang].associar_error ?? 'Não foi possível associar a entidade', '', 'info')
							})

					} catch (error) {
						console.log('GET entidade completa - erro', error)
						Swal.fire(language[lang].associar_error ?? 'Não foi possível associar a entidade', '', 'info')
					}
				}
			})
	}

	const club_id = dados.current?.id;
	const club_name = dados.current?.info?.name;

	const club_entities = club_id
		? (entities || []).filter(e => {
			const clubes = Array.isArray(e?.info?.clube) ? e.info.clube : (e?.info?.clube ? [e.info.clube] : []);
			return clubes.some(c => String(c?.id ?? '') === String(club_id));
		})
		: [];

	const get_entity_type_label = (e) => {
		const cat = e?.info?.attributes?.entity_category;
		const val = Array.isArray(cat) ? cat[0] : cat;
		return String(val) === '1'
			? (language[lang].interna ?? 'Interna')
			: (language[lang].externa ?? 'Externa');
	};

	const get_entity_profiles = (e) => {
		const pf = e?.info?.attributes?.entity_profile;
		if (!Array.isArray(pf)) return [];
		return pf.map(item =>
			typeof item === 'object' && item !== null
				? { id: String(item.id ?? ''), label: String(item.label ?? '').toLowerCase() }
				: { id: String(item ?? ''), label: '' }
		);
	};

	const is_athlete = (e) => get_entity_profiles(e).some(p => p.label.includes('praticante') || true);

	const is_board_member = (e) =>
		get_entity_profiles(e).some(p =>
			p.label.includes('presidente') ||
			p.label.includes('direção') ||
			p.label.includes('direcao') ||
			p.label.includes('diretor') ||
			p.label.includes('director')
		);

	const get_athlete_modalidades = (e) => {
		const mods = e?.info?.modalidades;
		
		if (Array.isArray(mods) && mods.length > 0) 
			return mods.map(m => m.label ?? m.name ?? m.value ?? m.id ?? m).join(', ');
		
		return e?.info?.modalidade ? String(e.info.modalidade) : '';
	};

	const get_athlete_numero_federacao = (e) =>
		e?.info?.numero_federacao ?? e?.info?.numero_licenca ?? e?.info?.numero_atleta ?? '';

	const get_entity_profile_labels = (e) => {
		const pf = e?.info?.attributes?.entity_profile;
		if (!Array.isArray(pf)) return '';
		return pf.map(item => (typeof item === 'object' && item !== null ? item.label : item)).filter(Boolean).join(', ');
	};

	const board_members = club_entities.filter(is_board_member);
	const athletes = club_entities.filter(is_athlete);

	const other_entities = club_entities.filter(e => !is_board_member(e) && !is_athlete(e));

	const join_labels = (valor) => {
		if (typeof valor === 'string') return valor || '-';
		if (!Array.isArray(valor) || valor.length === 0) return '-';
		return valor.map(el => (el && typeof el === 'object' ? (el.label ?? el.name ?? el.value) : el)).filter(Boolean).join(', ') || '-';
	};

	const flatten_por_epoca = (campo_por_epoca) => {
		if (!campo_por_epoca || typeof campo_por_epoca !== 'object') return []
		return Object.entries(campo_por_epoca).flatMap(([epoca, lista]) =>
			Array.isArray(lista) ? lista.map(item => ({ epoca, item })) : []
		)
	}

	// ================= ATLETAS DA COMPETIÇÃO (MODAL) =================

	const ver_atletas_competicao = (competicao) => {
		// Cópia, para as alterações locais não mexerem na lista `competicoes`
		// até serem gravadas.
		setSelectedCompeticaoAtletas(JSON.parse(JSON.stringify(competicao)))
		setAtletasPendentes([])
		setShowAtletasCompeticaoModal(true)
	}

	// Cancelar: fecha e descarta o que ainda não foi gravado
	const fecharAtletasCompeticaoModal = () => {
		setShowAtletasCompeticaoModal(false)
		setSelectedCompeticaoAtletas(null)
		setAtletasPendentes([])
	}

	// Ao escolher um atleta no select: só o adiciona à tabela (sem pedido à API)
	const selecionar_atleta_competicao = (atleta_id) => {
		if (!selectedCompeticaoAtletas || !atleta_id) return

		console.log('1 selectedCompeticaoAtletas', selectedCompeticaoAtletas)

		const epoca = normalizar_epoca(selectedCompeticaoAtletas?.info?.epoca)
		if (!epoca) return

		console.log('2 epoca', epoca)

		const atleta_entidade = athletes.find(a => String(a.id) === String(atleta_id))
		if (!atleta_entidade) return

		console.log('3 atleta_entidade', atleta_entidade)

		const atualizada = JSON.parse(JSON.stringify(selectedCompeticaoAtletas))
		if (atualizada.info.atletas_inscritos === undefined || atualizada.info.atletas_inscritos === null) {
			atualizada.info.atletas_inscritos = {}
		}
		if (!Array.isArray(atualizada.info.atletas_inscritos)) {
			atualizada.info.atletas_inscritos = []
		}

		console.log('4 atualizada', atualizada)
		

		const ja_inscrito = atualizada.info.atletas_inscritos.some(a => String(a.id) === String(atleta_entidade.id))
		if (ja_inscrito) {
			Swal.fire('', language[lang].atleta_ja_inscrito ?? 'Este atleta já está inscrito nesta época', 'info')
			return
		}

		console.log('5 ja_inscrito', ja_inscrito)

		// Só as modalidades em comum entre o atleta e a competição, e o escalão
		// calculado consoante essa(s) modalidade(s).
		const modalidades_competicao = get_registo_valores(atualizada, 'modalidades', 'modalidade')
		const overlapping = get_overlapping_modalidades(atleta_entidade, modalidades_competicao)
		const modalidades_label = overlapping
			.map(v => modalidades_lista.find(o => o.value === v)?.label ?? v)
			.join(', ')
		const modalidades_value = overlapping
			.map(v => modalidades_lista.find(o => o.value === v)?.value ?? v)
			.join(', ')
		const escalao_calculado = calcular_escalao_entidade(atleta_entidade, modalidades_competicao)

		// atualizada.info.atletas_inscritos[epoca] = [
		//	...atualizada.info.atletas_inscritos[epoca],
		atualizada.info.atletas_inscritos = [
			...atualizada.info.atletas_inscritos,
			{
				id: atleta_entidade.id,
				numero_licenca: atleta_entidade.info?.numero_licenca ?? '',
				label: atleta_entidade.info?.name ?? '',
				escalao: escalao_calculado,
				clube_id: club_id,
				modalidades: modalidades_value,
			}
		]

		console.log('5 atualizada', atualizada)
		console.log('5 atleta_entidade', atleta_entidade)

		setSelectedCompeticaoAtletas(atualizada)
		setAtletasPendentes(prev => [...prev, String(atleta_entidade.id)])
	}

	// Botão "Adicionar" do rodapé: grava na API
	const gravar_atletas_competicao = async () => {
		if (!selectedCompeticaoAtletas || atletasPendentes.length === 0) return

		const payload = {
			competicao_id: selectedCompeticaoAtletas.id,
			clube_id: club_id,
			atletas_inscritos: selectedCompeticaoAtletas.info.atletas_inscritos,
		}

		try {
			console.log('POST praticantes/competicao - payload enviado', payload)

			const res = await reqPOST(`${api_crud_base}/intranet/clube/add/praticantes/competicao/${getTokenInfo().companycode}`, payload)
			console.log('POST praticantes/competicao - resposta', res)

			const gravada = selectedCompeticaoAtletas
			setCompeticoes(prev => prev.map(c => String(c.id) === String(gravada.id) ? gravada : c))
			fecharAtletasCompeticaoModal()

			Swal.fire('', language[lang].atletas_adicionados ?? 'Atletas adicionados com sucesso', 'success')

		} catch (err) {
			console.error('Submission failed', err)
			Swal.fire(language[lang].associar_error ?? 'Não foi possível gravar', '', 'info')
		}
	}

	const get_data_func = () => {
		let data = moment().tz("Europe/Lisbon").format('YYYY-MM-DDTHH:mm:ss.SSSZ')
		return data.substring(0, data.length - 6) + 'Z'
	}

	const pagar_atletas_competicao = async () => {

		let valor_inscricao = 10
		let valor_total = 0.00

		let date_today = new Date()
		let timestamp_aux = get_data_func()

		set_dados(nota_de_encomenda.current = {
			id: '',
			info: {
				companycode: dados.current.info.companycode,
				tipo_documento: 'nota_de_encomenda_2',
				origin: 'web',
				numero: '',
				serie: '',
				data: date_today.getFullYear() + '-' + (date_today.getMonth() + 1).toString().padStart(2, '0') + '-' + date_today.getDate().toString().padStart(2, '0'), 	// 'AAAA-MM-DD',
				timestamp: timestamp_aux, 	// 'with all info',
				id_usado_para_gerar_pagamento: '',
				pagamento_pendente: 0,
				metodo_de_pagamento: 0,
				documento: {
					rmb: {
						rmb_ref: '',
						rmb_ent: '',
						rmb_pag: '',
					},
					user_info : {
						id_user: dados.current.id,
						username: dados.current.info.username,	// para fazer match
						name: dados.current.info.name,
						birthday: dados.current.info.birthday,
						numero_identificacao: dados.current.info.identificacao.numero_identificacao,
						clube: Array.isArray(dados.current.info.clube) && dados.current.info.clube.length > 0 ? dados.current.info.clube[0].name : '',
						numero_licenca: dados.current.info.numero_licenca,
						seguro_opcional: parseInt(dados.current.info.seguro_opcional) === 1 ? true : false,
						vat: dados.current.info.vat,
						addresses: dados.current.addresses,
						contacts: dados.current.contacts,
						obs: '',
					},
					linhas:[],
		
					// Valores do Globais do Documento
					total_iliquido_documento: 0.00,			                          				// soma do total_iliquido_com_desconto de todas as linhas 
					total_desconto_linha_documento: 0.00,                           				// soma do total_desconto de todas as linhas 
					taxa_desconto_global: 0,                                        				// em %
					valor_desconto_global_a_aplicar: 0.00, 
					total_iliquido_documento_com_deconto_linha_e_global: 0.00,						// total_iliquido_documento - (total_desconto_linha_documento + valor_desconto_global_a_aplicar)

					total_iva_documento: 0.00,
	
					total_documento: 0.00, 															// total_iliquido_documento_com_deconto_linha_e_global + total_iva_documento
				}
			}
		})

		console.log('atletas_da_competicao_selecionada', atletas_da_competicao_selecionada)
		let result = []
		atletas_da_competicao_selecionada.forEach(e => {
			if(e?.paid === undefined || e?.paid === null /*|| e.paid === 0*/) {
				e.paid = 0
				result.push(e)

				let linha = {
					id_produto: 					'',
					designacao: 					'Inscrição Competuição',
					subname: 						'',
					category: 						selectedCompeticaoAtletas.info.name,
					// observation:					(e.label) + ' | ' + (e.escalao) + ' | ' + (language[lang][e.modalidades]) + ' | ' + (temporada.current !== undefined && temporada.current !== null ? 'Temporada: ' + temporada.current.info.name : ''),
					observation:					(e.label) + ' | ' + (e.escalao),
					unidade: 						'un',

					escalao:						e.escalao,
					competicao: {
						id: selectedCompeticaoAtletas.id,
						name: selectedCompeticaoAtletas.info.name
					}, 	
					atleta: {
						id: e.id,
						name: e.label
					}, 	
					temporada: {
						id: temporada.current !== undefined && temporada.current !== null ? temporada.current.id : '',
						name: temporada.current !== undefined && temporada.current !== null ? temporada.current.info.name : ''
					}, 		

					quantidade: 					1.00,
					preco_unitario: 				valor_inscricao, 									// 0.00000000, 

					taxa_iva: 						0.00,
					taxa_desconto_linha: 			0.00,

					total_iliquido: 				valor_inscricao,                  		   			// preco_unitario * quantidade

					total_desconto: 				0.00,                   	           			// total_iliquido * taxa_desconto_linha * 0.01
					total_iliquido_com_desconto: 	valor_inscricao,              						// total_iliquido - total_desconto

					total_iva: 						0.00,                	                   		// total_iliquido_com_desconto * taxa_iva * 0.01
					total_com_iva: 					valor_inscricao,    	                       		// total_iliquido_com_desconto + total_iva

					total_liquido:					valor_inscricao 									// total_com_iva
				}
				set_dados(nota_de_encomenda.current.info.documento.linhas.push(linha))

				valor_total = parseFloat(valor_total) + parseFloat(valor_inscricao)
			}
		})

		console.log('valor_total', valor_total)
		set_dados(nota_de_encomenda.current.info.documento.total_iliquido_documento = valor_total)
		set_dados(nota_de_encomenda.current.info.documento.total_iliquido_documento_com_deconto_linha_e_global = valor_total)
		set_dados(nota_de_encomenda.current.info.documento.total_documento = valor_total)

		const payload = {
			entity: dados.current,
			competicao_id: selectedCompeticaoAtletas.id,
			clube_name: club_name,
			clube_id: club_id,
			temporada: temporada.current,
			atletas_inscritos: result,
		}


		console.log('nota_de_encomenda.current', nota_de_encomenda.current)


		document.getElementById('btn_modal_payment_type').click()

		// const res = await reqPOST(`${api_crud_base}/intranet/clube/pay/praticantes/competicao/${getTokenInfo().companycode}`, payload)

	}

	const set_paymet = async (type, id) => {
		console.log(type)





		set_dados(nota_de_encomenda.current.info['metodo_de_pagamento'] = id)

		let id_pagamento = Date.now() + '' + getTokenInfo().id
		set_dados(nota_de_encomenda.current.info['id_usado_para_gerar_pagamento'] = id_pagamento)

		if(type === 'mbw') {
			const { value: formValues } = await Swal.fire({
				title: 'Pagamento por MBWay',
				html:
					'<label>Número de telemóvel associado à aplicação MBWay</label>' +
					'<input id="swal-input1" type="text" class="form-control mb-2" required>',
				target: document.querySelector('.modal-content'), // 👈 Altera para a classe/ID da tua modal
				focusConfirm: false,
				showCancelButton: true,
				cancelButtonText: language[lang].cancel,
				preConfirm: () => {
					if(document.getElementById('swal-input1').value === '') {
						Swal.fire('', document.getElementById('swal-input1').value, 'info')
					}
					else {
						return [
							document.getElementById('swal-input1').value
						]
					}
				}
			})

			if(formValues) {
				if(formValues[0] !== undefined && formValues[0] !== '') {

					Swal.fire({
						title: language[lang].confirm_purchase_title,
						text: language[lang].confirm_purchase_text,
						icon: 'question',
						showCancelButton: true,
						confirmButtonColor: '#0095e8',
						cancelButtonColor: '#d9214e',
						confirmButtonText: language[lang].confirm_purchase_confirm,
						cancelButtonText: language[lang].confirm_purchase_cancel
					})
					.then((result) => {
						if (result.isConfirmed) {
			
							nota_de_encomenda.current.info['metodo_de_pagamento'] = id
			
							if(nota_de_encomenda.current.info.documento.user_info.vat === '') {
								nota_de_encomenda.current.info.documento.user_info.vat = '999999990'
							}

							reqPOST(`${Hosts.SIMCore_API}/store/order`, nota_de_encomenda.current)
								.then(() => { 
			
									if(nota_de_encomenda.current.info['metodo_de_pagamento'] === '-1') {
										get_payment_data('mbw', formValues[0])
									}
									else if(nota_de_encomenda.current.info['metodo_de_pagamento'] === '0') {
										get_payment_data('cc', '')
									}
									else if(nota_de_encomenda.current.info['metodo_de_pagamento'] === '1') {
										get_payment_data('mb', '')
									}

								})
								.catch(() => Swal.fire('', language[lang].confirm_purchase_error, 'info'))
				
						}
					})
				}
				else {
					Swal.fire({
					title: 'Pagamento por MBWay',
					html: 'É obrigatório introduzir o número de telemóvel associado à aplicação MBWay',
					timer: 2000,
					timerProgressBar: true,
					didOpen: () => {
					},
					willClose: () => {
						set_paymet(type, id)
					}
					}).then((result) => {
						if (result.dismiss === Swal.DismissReason.timer) {
							set_paymet(type, id)
						}
					})
				}
			}
		}
		else {
			console.log('-----333333')
			Swal.fire({
				title: language[lang].confirm_purchase_title,
				text: language[lang].confirm_purchase_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].confirm_purchase_confirm,
				cancelButtonText: language[lang].confirm_purchase_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					nota_de_encomenda.current.info['metodo_de_pagamento'] = id
	
					if(nota_de_encomenda.current.info.documento.user_info.vat === '') {
						nota_de_encomenda.current.info.documento.user_info.vat = '999999990'
					}

					reqPOST(`${Hosts.SIMCore_API}/store/order`, nota_de_encomenda.current)
						.then(() => { 
	
							if(nota_de_encomenda.current.info['metodo_de_pagamento'] === '-1') {
								get_payment_data('mbw', '')
							}
							else if(nota_de_encomenda.current.info['metodo_de_pagamento'] === '0') {
								get_payment_data('cc', '')
							}
							else if(nota_de_encomenda.current.info['metodo_de_pagamento'] === '1') {
								get_payment_data('mb', '')
							}
							else if(nota_de_encomenda.current.info['metodo_de_pagamento'] === '2') {
								get_payment_data('tb', '')
							}
							else if(nota_de_encomenda.current.info['metodo_de_pagamento'] === '') {
								get_payment_data('free', '')
							}

						})
						.catch(() => Swal.fire('', language[lang].confirm_purchase_error, 'info'))

				}
			})
		}

		if(type !== 'free') {
			document.getElementById('btn_modal_payment_type').click()
		}

	}

	const get_payment_data = async (type, mbw_number) => {

		set_dados(pay_fee_available.current = false)

		let body = { 
			key: nota_de_encomenda.current.info.id_usado_para_gerar_pagamento, 
			value: parseFloat(nota_de_encomenda.current.info.documento.total_documento), 
			method: type, 
			phone: mbw_number 
		}

		await reqPOST(`${Hosts.SIMCore_API}/store/payment/checkout/`, body)
			.then(async (res) => { 

				console.log('res', res)

				if(type === 'mb') {

				}
				else if(type === 'mbw') {

				}

				await reqPOST(`${Hosts.SIMCore_API}/store/purchase/payment`, {id: '', info: {id: '' + nota_de_encomenda.current.info.id_usado_para_gerar_pagamento + '', companycode: '' + nota_de_encomenda.current.info.companycode + '', obj: res.data} })
					.then(async () => { 

						console.log('DONE!!!')

						await reqGET(`${Hosts.SIMCore_API}/store/order/payment/${Hosts.companycode}/${nota_de_encomenda.current.info.id_usado_para_gerar_pagamento}`)
							.then(async () => { 

								if(type === 'cc') {

									console.log('CC', nota_de_encomenda.current.info['metodo_de_pagamento'])
									console.log('CC', res.data.response.method.url)

									// compose_email(res_2.data[0].id, type, '', '', '')
									window.open(res.data.response.method.url, '_self')

								}
								else if(type === 'mbw') {
									// Mensagem de sucesso
									console.log('MBW', nota_de_encomenda.current.info['metodo_de_pagamento'])

									Swal.fire({
										icon: 'info',
										html: language[lang].encomenda_finalizada,
										showConfirmButton: false
									})

									setTimeout(() => {
										// window.open(Hosts.WEB_SITE_URI, '_self')
									}, 3000);
								}
								else if(type === 'mb') {
									// Mensagem de sucesso

									console.log('MB', nota_de_encomenda.current.info['metodo_de_pagamento'])
									// compose_email(res_2.data[0].id, type, mb_e, mb_r, data_limite)

									await reqGET(`${Hosts.SIMCore_API}/store/order/payment/${Hosts.companycode}/${nota_de_encomenda.current.info.id_usado_para_gerar_pagamento}`)
										.then(async (res_order) => { 

											res_order.data[0].info.documento.rmb.rmb_ref = res.data.response.method.reference
											res_order.data[0].info.documento.rmb.rmb_ent = res.data.response.method.entity
											res_order.data[0].info.documento.rmb.rmb_pag = parseFloat(body.value).toFixed(2).toString().replace('.', ',')

											await reqPUT(`${Hosts.SIMCore_API}/store/order`, res_order.data[0] )
												.then(_ => {} )
												.catch(_ => {} ) 
		
											// Swal.fire('', language[lang].encomenda_finalizada, 'info')
		
											Swal.fire({
												icon: 'info',
												html: language[lang].encomenda_finalizada,
												showConfirmButton: false
											})
		
											setTimeout(() => {
												// window.open(Hosts.WEB_SITE_URI, '_self')
											}, 3000);

										})
										.catch(erro => console.log(erro)) 

								} 
								else if(type === 'tb') {
									// Mensagem de sucesso
									console.log('TB', nota_de_encomenda.current.info['metodo_de_pagamento'])

									Swal.fire({
										icon: 'info',
										html: language[lang].encomenda_finalizada,
										showConfirmButton: false
									})

									setTimeout(() => {
										// window.open(Hosts.WEB_SITE_URI, '_self')
									}, 3000);

								}
								else if(type === 'free') {
									// Mensagem de sucesso
									console.log('FREE', nota_de_encomenda.current.info['metodo_de_pagamento'])

									Swal.fire({
										icon: 'info',
										html: language[lang].encomenda_finalizada,
										showConfirmButton: false
									})

									setTimeout(() => {
										// window.open(Hosts.WEB_SITE_URI, '_self')
									}, 3000);

								}

							})
							.catch(erro => console.log(erro)) 

					})
					.catch(() => {

						console.log('error')

					})

			})
			.catch(() => {

				console.log('error')

			})

	}




	
	/*
	const remover_atleta_competicao = (atleta_id, epoca) => {
		if (!selectedCompeticaoAtletas) return

		const remover_de = (comp) => {
			const c = JSON.parse(JSON.stringify(comp))
			if (Array.isArray(c.info?.atletas_inscritos?.[epoca])) {
				c.info.atletas_inscritos[epoca] = c.info.atletas_inscritos[epoca].filter(a => String(a.id) !== String(atleta_id))
			}
			return c
		}

		// Ainda não foi gravado: só sai da tabela
		if (atletasPendentes.includes(String(atleta_id))) {
			setSelectedCompeticaoAtletas(remover_de(selectedCompeticaoAtletas))
			setAtletasPendentes(prev => prev.filter(id => id !== String(atleta_id)))
			return
		}

		Swal.fire({
			title: language[lang].remove_title ?? 'Remover',
			text: language[lang].remove_text ?? 'Confirma remover este atleta da competição?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].remove_confirm ?? 'Remover',
			cancelButtonText: language[lang].remove_cancel ?? 'Cancelar'
		}).then(async (result) => {
			if (!result.isConfirmed) return

			try {
				// Parte da versão gravada, para o PUT não levar os atletas pendentes
				const original = competicoes.find(c => String(c.id) === String(selectedCompeticaoAtletas.id)) ?? selectedCompeticaoAtletas
				const gravada = remover_de(original)

				console.log('PUT competicao - payload enviado', gravada)

				const res = await reqPUT(`${api_crud_base}/intranet/components`, gravada)
				console.log('PUT competicao - resposta', res)

				setCompeticoes(prev => prev.map(c => String(c.id) === String(gravada.id) ? gravada : c))
				setSelectedCompeticaoAtletas(prev => (prev ? remover_de(prev) : prev))

			} catch (err) {
				console.error('Submission failed', err)
				Swal.fire(language[lang].associar_error ?? 'Não foi possível gravar', '', 'info')
			}
		})
	}
	*/

	const remover_atleta_competicao = (atleta_id, epoca) => {
		if (!selectedCompeticaoAtletas) return

		if (Array.isArray(selectedCompeticaoAtletas.info?.atletas_inscritos)) {
			selectedCompeticaoAtletas.info.atletas_inscritos = selectedCompeticaoAtletas.info.atletas_inscritos.filter(a => String(a.id) !== String(atleta_id))
		}

		Swal.fire({
			title: language[lang].remove_title ?? 'Remover',
			text: language[lang].remove_text ?? 'Confirma remover este atleta da competição?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].remove_confirm ?? 'Remover',
			cancelButtonText: language[lang].remove_cancel ?? 'Cancelar'
		}).then(async (result) => {
			if (!result.isConfirmed) return

			try {

				const payload = {
					competicao_id: selectedCompeticaoAtletas.id,
					clube_id: club_id,
					atleta_id: atleta_id,
				}

				const res = await reqPOST(`${api_crud_base}/intranet/clube/remove/praticantes/competicao/${getTokenInfo().companycode}`, payload)
				console.log('POST praticantes/competicao - resposta', res)


			} catch (err) {
				console.error('Submission failed', err)
				Swal.fire(language[lang].associar_error ?? 'Não foi possível gravar', '', 'info')
			}
		})


		setRefresh(r => r + 1)
		console.log('selectedCompeticaoAtletas.info.atletas_inscritos', selectedCompeticaoAtletas.info.atletas_inscritos)

	}

	const registo_tem_este_clube = (registo) => {
		if (!club_id) return false
		return flatten_por_epoca(registo?.info?.clubes_inscritos)
			.some(({ item }) => String(item?.id) === String(club_id))
	}

	const get_flag_atletas_por_pagar = (atletas) => {
		console.log('atletas inscritos', atletas)

		let result = false
		if(Array.isArray(atletas)) {
			atletas.forEach(e => {
				if(e?.paid === undefined || e?.paid === null /*|| parseInt(e.paid) === 0*/) {
					result = true
				}
			})
		}

		return result
	}

	const club_competicoes = (competicoes || []).filter(registo_tem_este_clube);

	// const atletas_da_competicao_selecionada = flatten_por_epoca(selectedCompeticaoAtletas?.info?.atletas_inscritos)
	console.log('dados?.current?.id', dados?.current?.id)
	const atletas_da_competicao_selecionada = selectedCompeticaoAtletas?.info?.atletas_inscritos.filter(e => ((e?.clube_id !== undefined && dados?.current?.id !== undefined) && (parseInt(e.clube_id) === parseInt(dados.current.id))))
	const estado_da_competicao_selecionada = selectedCompeticaoAtletas?.info?.active // true // PARA TESTES
	// console.log('##############################')
	// console.log('##############################')
	// console.log('##############################')
	// console.log('##############################')
	// console.log('#### LEMBRAR RETIRAR TRUE ####')
	// console.log('##############################')
	// console.log('##############################')
	// console.log('##############################')
	// console.log('##############################')
	const flag_atletas_por_pagar = get_flag_atletas_por_pagar(atletas_da_competicao_selecionada)

	const epoca_da_competicao_selecionada = normalizar_epoca(selectedCompeticaoAtletas?.info?.epoca)

	const ids_ja_inscritos_na_epoca = (selectedCompeticaoAtletas?.info?.atletas_inscritos ?? [])
		.map(a => String(a.id))

	// Modalidades/escalões da própria competição, para só mostrar (e só
	// deixar adicionar) atletas que encaixem em ambos.
	const modalidades_competicao_selecionada = get_registo_valores(selectedCompeticaoAtletas, 'modalidades', 'modalidade')
	const escaloes_competicao_selecionada = get_registo_valores(selectedCompeticaoAtletas, 'escaloes', 'escalao')
	
	if (selectedCompeticaoAtletas) {
		console.log('DEBUG atletas_do_clube_disponiveis', {
			total_athletes: athletes.length,
			athletes_ids_e_nomes: athletes.map(a => `${a.id}:${a.info?.name}`),
			modalidades_competicao_selecionada,
			escaloes_competicao_selecionada,
			ids_ja_inscritos_na_epoca,
		})
	}

	const atletas_do_clube_disponiveis = athletes
		.filter(a => !ids_ja_inscritos_na_epoca.includes(String(a.id)))
		// .filter(a => entidade_pratica_modalidade(a, modalidades_competicao_selecionada))
		// .filter(a => entidade_esta_no_escalao(a, modalidades_competicao_selecionada, escaloes_competicao_selecionada))


	console.log('athletes', athletes)
	console.log('atletas_do_clube_disponiveis', atletas_do_clube_disponiveis)

	const refresh_modalidades = () => {

		console.log('entities', entities)

		let modalidades_clube = []
		entities.forEach(el => {
			// console.log('FOREACH modalidades_clube', modalidades_clube)
			// console.log('el.info.modalidades', el.info.modalidades)

			if(el?.info?.modalidades !== undefined) {
				let aux = el.info.modalidades.find(e => modalidades_clube.includes(e.id))
				// console.log('aux', aux)
				if(aux === undefined) {
					let aux_2 = el.info.modalidades.map(u => u.id).join(", ")
					if(aux_2.replaceAll(',', '').trim() !== '') {
						modalidades_clube.push(aux_2)
					}
				}
			}
		})
		// console.log('END modalidades_clube', modalidades_clube)
		set_dados(modalidades.current = modalidades_clube)


		let competicoes_clube_aux = []
		competicoes.forEach(el => {
			// console.log('FOREACH competicoes_clube_aux', competicoes_clube_aux)
			// console.log('FOREACH modalidades_clube', modalidades_clube)
			// console.log('el.info.modalidades', el.info.modalidades)
			
			if(el?.info?.modalidades !== undefined) {
				let aux = el.info.modalidades.find(e => modalidades_clube.includes(e.value))
				// console.log('competicoes aux', aux)
				if(aux !== undefined) {
					competicoes_clube_aux.push(el)
				}
			}
		})
		// console.log('END competicoes_clube_aux', competicoes_clube_aux)
		set_dados(competicoes_clube.current = competicoes_clube_aux)

	}

	const add_dirigente = () => {
		console.log('modal_add_dirigente_clube.current', modal_add_dirigente_clube.current)
		console.log('JSON.parse(JSON.stringify(data_interface.contacts[0].person_responsables[0]))', JSON.parse(JSON.stringify(data_interface.contacts[0].person_responsables[0])))
		set_dados(modal_add_dirigente_clube.current = JSON.parse(JSON.stringify(data_interface.contacts[0].person_responsables[0])))
		console.log('modal_add_dirigente_clube.current', modal_add_dirigente_clube.current)

		setRefresh(r => r + 1)
		document.getElementById('btn_add_dirigente').click()

	}

	const edit_modal_dirigente = (order) => {

		modal_add_dirigente_clube.current = dados.current.contacts[0].person_responsables[order]
		set_dados(modal_is_edit.current = true)
		set_dados(modal_is_edit_order.current = order)

		setRefresh(r => r + 1)
		document.getElementById('btn_add_dirigente').click()

		console.log('modal_add_dirigente_clube.current', modal_add_dirigente_clube.current)

	}

	const change_modal_dirigente_field = (e) => {
		const {name, value} = e.target

		console.log('name', name)
		console.log('value', value)
		set_dados(modal_add_dirigente_clube.current[name] = value)
		setRefresh(r => r + 1)

		console.log('modal_add_dirigente_clube.current', modal_add_dirigente_clube.current)

	}

	const save_modal_dirigente = () => {

		if(dados.current.contacts[0].person_responsables[0].name === '') {
			dados.current.contacts[0].person_responsables = []
		}

		if(modal_is_edit.current) {
			if(parseInt(modal_is_edit_order.current) >= 0) {
				dados.current.contacts[0].person_responsables[modal_is_edit_order.current] = modal_add_dirigente_clube.current
			}
		}
		else {
			dados.current.contacts[0].person_responsables.push(modal_add_dirigente_clube.current)
		}
		dirigentes_clube.current = dados.current.contacts[0].person_responsables
		set_dados(modal_add_dirigente_clube.current = {})
	
		set_dados(modal_is_edit.current = false)
		set_dados(modal_is_edit_order.current = -1)

		setRefresh(r => r + 1)
		console.log('dados.current.contacts[0].person_responsables', dados.current.contacts[0].person_responsables)
	}

	const remove_dirigente = (order) => {

		console.log('order', order)

		if(parseInt(order) === 0 && dados.current.contacts[0].person_responsables.length === 1) {
			console.log('1111')
			dados.current.contacts[0].person_responsables = JSON.parse(JSON.stringify(data_interface.contacts[0].person_responsables[0]))
		}
		else if(parseInt(order) === 0 && dados.current.contacts[0].person_responsables.length > 1) {
			console.log('2222')
			dados.current.contacts[0].person_responsables.shift();
		}
		else {
			console.log('3333')
			dados.current.contacts[0].person_responsables.splice(order, order);
		}
		dirigentes_clube.current = dados.current.contacts[0].person_responsables

		console.log('dados.current.contacts[0].person_responsables', dados.current.contacts[0].person_responsables)
		setRefresh(r => r + 1)
	}

	const fetch_clubes = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Clube`)
			if(Array.isArray(res.data)) {
				set_dados(clubes.current = res.data)
			}
		} catch (error) {
			console.error('Erro ao carregar lista de clubes:', error)
		}
	}
	
	const get_team_logo = (id) => {

		let result = repo_img_link('nophoto.webp')
		let aux = clubes.current.find(e_c => parseInt(e_c.id) === parseInt(id))

		if(aux !== undefined) {
			if(aux.logo !== undefined && aux.logo !== null) {
				let aux_logo = JSON.parse(aux.logo)

				if(Array.isArray(aux_logo) && aux_logo.length > 0) {
					result = aux_logo[0]?.link
				}
			}
		}

		return result
	}
	
	const soma_periodos = (obj) => {

		if(obj?.p1 !== undefined && obj?.p1 !== null && obj?.p1 !== '') {
			let p1 = parseInt(obj?.p1, 10) || 0
			let p2 = parseInt(obj?.p2, 10) || 0
			let p3 = parseInt(obj?.p3, 10) || 0
			let ot = parseInt(obj?.ot, 10) || 0
			return p1 + p2 + p3 + ot
		}
		else {
			return ''
		}

	}

	return isloading || temporada.current === undefined ?
		<Loader />
	:
	isRedirect ?
		<Redirect to={endpoints.list} replace />
	:
		<main>
			<div className={`dash-cards header`}>
				<h2 className="dash-title">{language[lang].entity}</h2>
				<p>{language[lang].entity} / {dados.current.id !== '' ? language[lang].entity_edit : language[lang].entity_new}</p>
			</div>

			<div className={`dash-cards body`}>
				<div className="container">

					<div className="row">
						<div className="col-12 mb-5 mb-xl-10">
							<div className="card">
								<div className="card-header border-0 d-flex justify-content-sm-between" aria-expanded="true" aria-controls="div_entidade_info">
									<div className="card-title m-0">
										<h3 className="fw-bolder m-0">{language[lang].my_clube_data}</h3>
									</div>
									<div className="card-toolbar">
										<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
											<li className="nav-item">
												<a className={"btn btn-sm btn-secondary rounded-0 multi-item active"} data-bs-toggle="tab" href={"#tab_pane_info_language_0"}>{language[lang].my_clube_data}</a>
											</li>
											<li className="nav-item">
												<a className={"btn btn-sm btn-secondary rounded-0 multi-item "} data-bs-toggle="tab" href={"#tab_pane_dirigentes_0"}>{language[lang].tab_dirigentes}</a>
											</li>
											<li className="nav-item">
												<a className={"btn btn-sm btn-secondary rounded-0 multi-item "} data-bs-toggle="tab" href={"#tab_pane_athelete_0"}>{language[lang].tab_athelete}</a>
											</li>
											<li className="nav-item">
												<a className={"btn btn-sm btn-secondary rounded-0 multi-item"} onClick={() => refresh_modalidades()} data-bs-toggle="tab" href={"#tab_pane_competition_0"}>{language[lang].tab_competition}</a>
											</li>
										</ul>
									</div>
								</div>

								<div className="card-body border-top p-4">
									<div className='tab-content'>

										<div id="tab_pane_info_language_0" className="tab-pane active" role="tabpanel">
											<form id="form" onSubmit={handleSubmit}>
											
												<div className="row g-3 mb-4">
													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].name}</label>
														<input type="text" name="name" value={dados.current.info.name} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].name_placeholder} onChange={handle_change_info} required />
													</div>

													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].data_constituicao}</label>
														<input type="date" name="data_constituicao" value={dados.current.info.data_constituicao} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].data_constituicao_placeholder} onChange={handle_change_info} required />
													</div>

													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].data_filiacao}</label>
														<input type="date" name="data_filiacao" value={dados.current.info.data_filiacao} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].data_constituicao_placeholder} onChange={handle_change_info} required />
													</div>
												</div>

												<div className="row g-3 mb-4">
													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].vat}</label>
														<input type="text"
															pattern={pattern_vat}
															minLength="9"
															inputMode='numeric'
															name="vat"
															value={dados.current.info.vat}
															className="form-control rounded-0"
															placeholder={language[lang].vat_placeholder}
															onChange={handle_change_info}
														/>
													</div>

													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].email}</label>
														<input type="email" pattern={pattern_email} name="email" value={(dados.current.info.email != undefined && dados.current.info.email != '' ? dados.current.info.email : dados.current.contacts[0].email) || ''} className="form-control rounded-0" placeholder={language[lang].email_placeholder} onChange={handle_change_info} />
													</div>

													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].phone}</label>
														<PhoneInput
															defaultCountry="PT"
															className="form-control rounded-0"
															placeholder={language[lang].phone_placeholder}
															value={dados.current.info.phone !== '' ? dados.current.info.phone : null}
															onChange={e => set_dados(dados.current.info.phone = e)}
														/>
													</div>
												</div>

												<div className="row g-3 mb-4">
													<div className="col-8">
														<label className="form-label fw-bold fs-6">{language[lang].morada}</label>
														<textarea name="address_detail" value={dados.current.addresses[0].address_detail || ''} className="form-control rounded-0" rows="3" onChange={handle_change_addresses} />
													</div>

													<div className="col-md-4 mb-3 p-4 bg-white shadow-sm rounded">
														<label className="form-label fw-bold fs-6 d-block">{language[lang].logo}</label>
														<ul className="list-unstyled d-flex flex-wrap gap-3 mt-3 justify-content-center">
															{
																photo_base64 !== '' ?
																	<img
																		src={photo_base64}
																		className="img-fluid rounded"
																		alt="Uploaded"
																		style={{ width: "120px", height: "120px", objectFit: "cover" }}
																	/>
																	:
																	dados?.current?.info?.logo?.length > 0 ? (
																		dados.current.info.logo.map((file, index) => {
																			const imageURL = file.link || URL.createObjectURL(file);
																			return (
																				<li key={index} className="d-flex flex-column align-items-center">
																					<img
																						src={imageURL}
																						className="img-fluid rounded"
																						alt="Uploaded"
																						style={{ width: "120px", height: "120px", objectFit: "cover" }}
																					/>
																					<small className="mt-2 text-muted d-none">{file.name || 'Imagem'}</small>
																				</li>
																			);
																		})
																	) : (
																		<li className="text-muted">{language[lang].noLogo}</li>
																	)}
														</ul>

														<div className="d-flex justify-content-center mt-4 gap-2">
															<input
																type="file"
																accept="image/*"
																onChange={onChangeHandlerFilesImage}
																data-order={1}
																data-langid={lang_id}
																data-lang={lang}
																data-type={'image'}
																className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																id="logo-upload"
															/>

															<label htmlFor="logo-upload" className="btn btn-outline-primary btn-sm rounded-0">
																{language[lang].logo_choose}
															</label>

															{dados?.current?.info?.logo?.length > 0 && (
																<button
																	type="button"
																	className="btn btn-sm btn-danger rounded-0"
																	onClick={handleFileRemove}
																>
																	<i className="bi bi-x-lg"></i>
																</button>
															)}
														</div>
													</div>
												</div>
													
												<div className="row g-3 mb-4">

													<div className="col-6 col-md-3 mb-3">
														<label className="fs-6 fw-bold mb-2">{language[lang].country} *</label>
														<input
															type="text"
															name="country"
															value={dados.current.addresses[0].country}
															className="form-control rounded-0 d-none"
															placeholder={language[lang].country_placeholder}
															onChange={handle_change_addresses}
															required
														/>
														<Select
															className="div-select"
															options={countries}
															name="country"
															value={dados?.current?.addresses[0]?.country === '' ? null : { label: dados.current.addresses[0].country, value: dados.current.addresses[0].country }}
															placeholder={language[lang].country_placeholder}
															onChange={change_country}
														/>
													</div>
													{
													dados.current.addresses[0].country !== undefined && dados.current.addresses[0].country.toLowerCase() === 'portugal' ?
														<div className={"col-6 col-md-3 mb-3" + (dados.current.addresses[0].country !== undefined && dados.current.addresses[0].country.toLowerCase() === 'portugal' ? '' : ' d-none')}>
															<label className="fs-6 fw-bold mb-2">{language[lang].district} *</label>
															<input
																type="text"
																name="region"
																value={dados.current.addresses[0].region}
																className="form-control rounded-0 d-none"
																placeholder={language[lang].district_placeholder}
																onChange={handle_change_addresses}
																required
															/>
															<Select
																className="div-select"
																options={districts}
																name="distrito"
																value={dados.current.addresses[0].region === '' ? null : { label: dados.current.addresses[0].region, value: dados.current.addresses[0].region }}
																placeholder={language[lang].district_placeholder}
																onChange={change_district}
															/>
														</div>
													:
														null
													}

													{
													dados.current.addresses[0].country !== undefined && dados.current.addresses[0].country.toLowerCase() === 'portugal' ?
														<div className={"col-6 col-md-3 mb-3" + (dados.current.addresses[0].country !== undefined && dados.current.addresses[0].country.toLowerCase() === 'portugal' ? '' : ' d-none')}>
															<label className="fs-6 fw-bold mb-2">{language[lang].city} *</label>
															<input
																type="text"
																name="city"
																value={dados.current.addresses[0].city}
																className="form-control rounded-0 d-none"
																placeholder={language[lang].city_placeholder}
																onChange={handle_change_addresses}
																required
															/>
															<Select
																className="div-select"
																options={cities}
																name="concelho"
																value={dados.current.addresses[0].city === '' ? null : { label: dados.current.addresses[0].city, value: dados.current.addresses[0].city }}
																placeholder={language[lang].city_placeholder}
																onChange={change_city}
															/>
														</div>
													:
														null
													}
													
													{
													dados.current.addresses[0].country !== undefined && dados.current.addresses[0].country.toLowerCase() === 'portugal' ?
														<div className={"col-6 col-md-3 mb-3" + (dados.current.addresses[0].country !== undefined && dados.current.addresses[0].country.toLowerCase() === 'portugal' ? '' : ' d-none')}>
															<label className="fs-6 fw-bold mb-2">{language[lang].village} *</label>
															<input
																type="text"
																name="village"
																value={dados.current.addresses[0].village}
																className="form-control rounded-0 d-none"
																placeholder={language[lang].village_placeholder}
																onChange={handle_change_addresses}
																required
															/>
															<Select
																className="div-select"
																options={villages}
																name="concelho"
																value={dados.current.addresses[0].village === '' ? null : { label: dados.current.addresses[0].village, value: dados.current.addresses[0].village }}
																placeholder={language[lang].village_placeholder}
																onChange={change_village}
															/>
														</div>
													:
														null
													}
													
													{
													dados.current.addresses[0].country !== undefined && dados.current.addresses[0].country.toLowerCase() === 'portugal' ?
														<div className={"col-6 col-md-3 mb-3" + (dados.current.addresses[0].country !== undefined && dados.current.addresses[0].country.toLowerCase() === 'portugal' ? '' : ' d-none')}>
															<label className="fs-6 fw-bold mb-2">{language[lang].postal_code} *</label>
															<input
																type="text"
																name="postal_code"
																value={dados.current.addresses[0].postal_code}
																className="form-control rounded-0"
																placeholder={language[lang].postal_code_placeholder}
																onChange={handle_change_addresses}
																required
															/>
														</div>
													:
														null
													}

													<div className="col-6 col-md-3 mb-3">
														<label className="fs-6 fw-bold mb-2">{language[lang].local} *</label>
														<input
															type="text"
															name="localidade"
															value={dados.current.addresses[0].localidade}
															className="form-control rounded-0"
															placeholder={language[lang].local_placeholder}
															onChange={handle_change_addresses}
															required
														/>

													</div>

												</div>

												<div className="row g-3 mb-4">
													<div className="col-md-6">
														<label className="form-label fw-bold fs-6">{language[lang].modalidades ?? 'Modalidades'}</label>
														<Select
															isMulti
															className="div-select"
															options={modalidades_lista}
															name="modalidades"
															value={
																Array.isArray(dados.current.info.modalidades)
																	? dados.current.info.modalidades.map(m => ({
																		label: m.label ?? m,
																		value: m.value ?? m,
																	}))
																	: []
															}
															placeholder={language[lang].modalidades_placeholder ?? 'Selecione as modalidades'}
															onChange={change_modalidades}
														/>
													</div>
												</div>
											</form>

											<div className="card mt-5">
												<div className="card-header border-0">
													<div className="card-title m-0">
														<h3 className="fw-bolder m-0">{language[lang].ficheiros_da_associacao ?? 'Ficheiros da Associação'}</h3>
													</div>
												</div>
												<div className="card-body border-top p-4">
													<div className="row g-4">
														<div className="col-6 col-md-4">
															<DocUploadField
																field="constituicao_associacao"
																label={language[lang].constituicao_associacao ?? 'Constituição de Associação'}
																dados={dados}
																language={language}
																lang={lang}
																onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
																handleDocRemove={handleDocRemove}
																edit_element_tree_doc={edit_element_tree_doc}
																open_link={open_link}
																copy_clipboard={copy_clipboard}
															/>
														</div>
														<div className="col-6 col-md-4">
															<DocUploadField
																field="estatutos"
																label={language[lang].estatutos ?? 'Estatutos'}
																dados={dados}
																language={language}
																lang={lang}
																onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
																handleDocRemove={handleDocRemove}
																edit_element_tree_doc={edit_element_tree_doc}
																open_link={open_link}
																copy_clipboard={copy_clipboard}
															/>
														</div>
														<div className="col-6 col-md-4">
															<DocUploadField
																field="acta_tomada_posse"
																label={language[lang].acta_tomada_posse ?? 'Acta de tomada de posse'}
																dados={dados}
																language={language}
																lang={lang}
																onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
																handleDocRemove={handleDocRemove}
																edit_element_tree_doc={edit_element_tree_doc}
																open_link={open_link}
																copy_clipboard={copy_clipboard}
															/>
														</div>
													</div>
												</div>
											</div>
					
											<div className="card mt-5">
												<div className="card-header border-0">
													<div className="card-title m-0">
														<h3 className="fw-bolder m-0">{language[lang].contrato_programa ?? 'Contrato Programa'}</h3>
													</div>
												</div>
												<div className="card-body border-top p-4">
													<div className="row g-4">
														<div className="col-6 col-md-4">
															<DocUploadField
																field="contrato_programa"
																label={language[lang].contrato_programa ?? 'Contrato Programa'}
																dados={dados}
																language={language}
																lang={lang}
																onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
																handleDocRemove={handleDocRemove}
																edit_element_tree_doc={edit_element_tree_doc}
																open_link={open_link}
																copy_clipboard={copy_clipboard}
															/>
														</div>
														<div className="col-6 col-md-4">
															<DocUploadField
																field="declaracoes_ss"
																label={language[lang].declaracoes_ss ?? 'Declarações SS'}
																dados={dados}
																language={language}
																lang={lang}
																onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
																handleDocRemove={handleDocRemove}
																edit_element_tree_doc={edit_element_tree_doc}
																open_link={open_link}
																copy_clipboard={copy_clipboard}
															/>
														</div>
														<div className="col-6 col-md-4">
															<DocUploadField
																field="declaracoes_at"
																label={language[lang].declaracoes_at ?? 'Declarações AT'}
																dados={dados}
																language={language}
																lang={lang}
																onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
																handleDocRemove={handleDocRemove}
																edit_element_tree_doc={edit_element_tree_doc}
																open_link={open_link}
																copy_clipboard={copy_clipboard}
															/>
														</div>
													</div>

													<div className="row g-4">
														<div className="col-6 col-md-4">
															<DocUploadField
																field="plano_atividades"
																label={language[lang].plano_atividades ?? 'Plano de Atividades'}
																dados={dados}
																language={language}
																lang={lang}
																onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
																handleDocRemove={handleDocRemove}
																edit_element_tree_doc={edit_element_tree_doc}
																open_link={open_link}
																copy_clipboard={copy_clipboard}
															/>
														</div>
														<div className="col-6 col-md-4">
															<DocUploadField
																field="relatorio_intermedio"
																label={language[lang].relatorio_intermedio ?? 'Relatório Intermédio'}
																dados={dados}
																language={language}
																lang={lang}
																onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
																handleDocRemove={handleDocRemove}
																edit_element_tree_doc={edit_element_tree_doc}
																open_link={open_link}
																copy_clipboard={copy_clipboard}
															/>
														</div>
														<div className="col-6 col-md-4">
															<DocUploadField
																field="relatorio_final"
																label={language[lang].relatorio_final ?? 'Relatório Final'}
																dados={dados}
																language={language}
																lang={lang}
																onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
																handleDocRemove={handleDocRemove}
																edit_element_tree_doc={edit_element_tree_doc}
																open_link={open_link}
																copy_clipboard={copy_clipboard}
															/>
														</div>
													</div>
												</div>
											</div>

											<div className="card mt-5">
												<div className="card-header border-0" aria-expanded="true" aria-controls="div_entidade_password">
													<div className="card-title m-0">
														<h3 className="fw-bolder m-0">{language[lang].login_data}</h3>
													</div>
												</div>
												<div id="div_entidade_password" className="collapse show">
													<form id="form_pass" onSubmit={handleSubmitPassword}>

														<div className="card-body border-top p-4">

															<div className="row mb-6">
																<div className="col-md-4 fv-row">
																	<label className="fs-6 fw-bold mb-2">{language[lang].username}</label>
																	<input type="text" name="username" value={dados.current.info.username} pattern="[a-zA-Z\u00C0-\u00FF.]+" className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].username_placeholder} onChange={handle_change_info} onBlur={handle_change_login} autoComplete="off" required />
																</div>
																<div className="col-md-4 fv-row">
																	<label className="fs-6 fw-bold mb-2">{language[lang].password}</label>
																	<input type="password" name="password" value={new_password} min="9" title="A password deve de conter pelo menos 9 digitos alfa-númericos" className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onChange={handle_change_info_new_password} autoComplete="off" />
																</div>
																<div className="col-md-4 fv-row">
																	<label className="fs-6 fw-bold mb-2">{language[lang].password_confirmation}</label>
																	<input type="password" name="password_conf" defaultValue={confirm_password} min="9" className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onBlur={handle_change_password} autoComplete="off" />
																</div>
															</div>

															<div className="card-footer d-flex justify-content-end py-6 px-9 d-none">
																<Link className="btn btn-light btn-active-light-primary me-2" to={{ pathname: endpoints.list }}  >
																	<span>{language[lang].cancel}</span>
																</Link>

																<button onClick={() => apagar(dados.current.id)} className={show_delete_button ? "btn btn-danger me-2" : "d-none"}>
																	<span>{language[lang].delete}</span>
																</button>

																<button type="submit" form="form_pass" className="btn btn-primary">
																	<span>{language[lang].save}</span>
																</button>
															</div>
														</div>
													</form>
												</div>
											</div>

										</div>

										<div id="tab_pane_dirigentes_0" className="tab-pane" role="tabpanel">

											<div className="card mt-5">
												<div className="card-header border-0 d-flex justify-content-between">
													<div className="card-title m-0">
														<h3 className="fw-bolder m-0">{language[lang].dirigentes ?? 'Dirigentes'}</h3>
													</div>
													<div>
														<button
															type="button"
															className="btn btn-sm btn-primary"
															disabled={!dados.current?.id}
															onClick={() => add_dirigente()}
														>
															<i className="bi bi-person-plus me-2"></i>
															{language[lang].associar_entidade ?? 'Adiconar Dirigente'}
														</button>
													</div>
												</div>
												<div className="card-body border-top p-4">
													<div className="div-table">
														<div className="table-body table-responsive">
															<table className="table table-hover table-bordered align-middle">
																<thead>
																	<tr>
																		<th className='lh-lg p-3'>{language[lang].name ?? 'Nome'}</th>
																		<th className='lh-lg p-3'>{language[lang].function ?? 'Cargo'}</th>
																		<th className='lh-lg p-3'>{language[lang].contacto ?? 'Contacto'}</th>
																		<th className='lh-lg p-3'>{language[lang].email ?? 'Email'}</th>
																		<th className='lh-lg p-3'></th>
																	</tr>
																</thead>
																<tbody>
																	{dirigentes_clube.current.length > 0 ? (
																		dirigentes_clube.current.map((el, k) => (
																			<tr key={el.id ?? k}>
																				<td className='p-3 text-nowrap'>{el.name}</td>
																				<td className='p-3 text-center'>{el.position}</td>
																				<td className='p-3 text-center'>{el.mobile_phone}</td>
																				<td className='p-3 text-center'>{el.email}</td>
																				<td className="p-3 text-end">
																					<button type="button" className="btn btn-sm btn-primary rounded-0 me-2" onClick={() => edit_modal_dirigente(k)}>
																						<i className="bi bi-pencil"></i>
																					</button>

																					<button type="button" className="btn btn-sm btn-danger rounded-0 me-2" onClick={() => remove_dirigente(k)}>
																						<i className="bi bi-x-lg"></i>
																					</button>
																				</td>
																			</tr>
																		))
																	) : (
																		<tr>
																			<td colSpan="5" className="text-center text-muted">
																				{language[lang].sem_registos ?? 'Sem registos'}
																			</td>
																		</tr>
																	)}
																</tbody>
															</table>
														</div>
													</div>
												</div>
											</div>

										</div>
										
										<div id="tab_pane_athelete_0" className="tab-pane" role="tabpanel">
											<div className="card d-none">
												<div className='row'>
													<div className='col-12 text-end mb-3'>
														<button
															type="button"
															className="btn btn-sm btn-primary"
															disabled={!dados.current?.id}
															title={!dados.current?.id ? (language[lang].associar_precisa_gravar ?? 'Grave o clube primeiro para poder associar entidades') : ''}
															onClick={() => setShowAssociarModal(true)}
														>
															<i className="bi bi-person-plus me-2"></i>
															{language[lang].associar_entidade ?? 'Associar Entidade'}
														</button>
													</div>
												</div>
												<div className="card-header border-0 d-flex justify-content-between align-items-center">
													<div className="card-title m-0">
														<h3 className="fw-bolder m-0">{language[lang].direcao_clube ?? 'Presidentes e Direção'}</h3>
													</div>
												</div>
												<div className="card-body border-top p-4">

													<div className="row g-3 mb-4 d-none">
														<div className="col-md-6">
															<label className="form-label fw-bold fs-6">{language[lang].presidente ?? 'Presidente'}</label>
															<select
																name="presidente"
																className="form-select rounded-0"
																value={dados?.current?.info?.presidente?.id ?? ''}
																onChange={change_presidente}
															>
																<option value="">{language[lang].select ?? 'Selecione'}</option>
																{board_members.map((el, k) => (
																	<option key={el.id ?? k} value={el.id}>
																		{el.info?.name}
																	</option>
																))}
															</select>
														</div>
													</div>

													<div className="div-table">
														<ClubEntitiesTable
															entities={board_members}
															language={language}
															lang={lang}
															get_athlete_numero_federacao={get_athlete_numero_federacao}
															get_entity_profile_labels={get_entity_profile_labels}
															get_athlete_modalidades={get_athlete_modalidades}
															get_entity_type_label={get_entity_type_label}
															epoca_atual={temporada.current}
															highlightId={dados?.current?.info?.presidente?.id}
															highlightLabel={language[lang].presidente ?? 'Presidente'}
														/>
													</div>
												</div>
											</div>

											<div className="card d-none">
												<div className="card-header border-0">
													<div className="card-title m-0">
														<h3 className="fw-bolder m-0">{language[lang].atletas ?? 'Atletas'}</h3>
													</div>
												</div>
												<div className="card-body border-top p-4">
													<div className="div-table">
														<ClubEntitiesTable
															entities={athletes}
															language={language}
															lang={lang}
															get_athlete_numero_federacao={get_athlete_numero_federacao}
															get_entity_profile_labels={get_entity_profile_labels}
															get_athlete_modalidades={get_athlete_modalidades}
															get_entity_type_label={get_entity_type_label}
															epoca_atual={temporada.current}
														/>
													</div>
												</div>
											</div>

											<div className="card d-none">
												<div className="card-header border-0">
													<div className="card-title m-0">
														<h3 className="fw-bolder m-0">{language[lang].outros_atletas ?? 'Outros Atletas'}</h3>
													</div>
												</div>
												<div className="card-body border-top p-4">
													<div className="div-table">
														<ClubEntitiesTable
															entities={other_entities}
															language={language}
															lang={lang}
															get_athlete_numero_federacao={get_athlete_numero_federacao}
															get_entity_profile_labels={get_entity_profile_labels}
															get_athlete_modalidades={get_athlete_modalidades}
															get_entity_type_label={get_entity_type_label}
															epoca_atual={temporada.current}
														/>
													</div>
												</div>
											</div>

											<div className="card">
												<div className="card-header border-0">
													<div className="card-title m-0">
														<h3 className="fw-bolder m-0">{language[lang].atletas ?? 'Atletas'}</h3>
													</div>
												</div>
												<div className="card-body border-top p-4">
													<div className="div-table">
														<ClubEntitiesTable
															entities={club_entities}
															language={language}
															lang={lang}
															get_athlete_numero_federacao={get_athlete_numero_federacao}
															get_entity_profile_labels={get_entity_profile_labels}
															get_athlete_modalidades={get_athlete_modalidades}
															get_entity_type_label={get_entity_type_label}
															epoca_atual={temporada.current}
														/>
													</div>
												</div>
											</div>
										</div>

										<div id="tab_pane_competition_0" className="tab-pane" role="tabpanel">

											<div className="card mt-5">
												<div className="card-header border-0">
													<div className="card-title m-0">
														<h3 className="fw-bolder m-0">{language[lang].competicoes ?? 'Competições'}</h3>
													</div>
												</div>
												<div className="card-body border-top p-4">
													<div className="div-table">
														<div className="table-body table-responsive">
															<table className="table table-hover table-bordered align-middle">
																<thead>
																	<tr>
																		<th className='lh-lg p-3' style={{maxWidth: '150px'}}>{language[lang].competicao ?? 'Competição'}</th>
																		<th className='lh-lg p-3'>{language[lang].tipo_competicao ?? 'Tipo'}</th>
																		<th className='lh-lg p-3'>{language[lang].modalidades ?? 'Modalidades'}</th>
																		<th className='lh-lg p-3'>{language[lang].escaloes ?? 'Escalão(ões)'}</th>
																		<th className='lh-lg p-3'>{language[lang].epoca ?? 'Época'}</th>
																		<th className='lh-lg p-3'>{language[lang].data_referencia ?? 'Data'}</th>
																		<th className='lh-lg p-3' style={{minWidth: '195px'}}></th>
																	</tr>
																</thead>
																<tbody>
																	{competicoes_clube.current.length > 0 ? (
																		competicoes_clube.current.map((el, k) => (
																			<tr key={el.id ?? k}>
																				<td className='p-3 text-wrap'>{el.info?.name ?? '-'}</td>
																				<td className='p-3 text-center'>{get_label(tipo_competicao_lista, el.info?.tipo_competicao)}</td>
																				<td className='p-3 text-center'>{join_labels(el.info?.modalidades)}</td>
																				<td className='p-3'>{join_labels(el.info?.escaloes)}</td>
																				<td className='p-3 text-center'>{el.info?.epoca?.name ?? '-'}</td>
																				<td className='p-3 text-nowrap text-center'>{el.info?.data_referencia ?? '-'}</td>
																				<td className="p-3 text-end">
																					<button type="button" className="btn btn-sm btn-outline-primary mt-1" onClick={() => ver_atletas_competicao(el)}>
																						{language[lang].ver_atletas ?? 'Ver Atletas'}
																					</button>
																					<button type="button" className="btn btn-sm btn-outline-primary ms-2 mt-1" data-bs-toggle="modal" data-bs-target={"#see_games"} onClick={() => set_dados(competicao_el.current = el)}>
																						{language[lang].see_games ?? 'Ver Jogos'}
																					</button>
																				</td>
																			</tr>
																		))
																	) : (
																		<tr>
																			<td colSpan="7" className="text-center text-muted">
																				{language[lang].sem_registos ?? 'Sem registos'}
																			</td>
																		</tr>
																	)}
																</tbody>
															</table>
														</div>
													</div>
												</div>
											</div>

										</div>

									</div>
								</div>
							</div>
							
							{showAtletasCompeticaoModal && (
								<div style={modalStyles.modalOverlay} onClick={fecharAtletasCompeticaoModal}>
									<div style={{ ...modalStyles.modalContent, width: '800px', maxHeight: '80vh', overflowY: 'auto' }} onClick={(e) => e.stopPropagation()}>
										<div style={modalStyles.taskListContainer}>
											<label className="form-label fw-bold fs-6 d-block mb-3">
												{(language[lang].atletas_da_competicao ?? 'Atletas de') + ' ' + (selectedCompeticaoAtletas?.info?.name ?? '')}
											</label>
												{console.log('SelectedCompeticaoAtletas', selectedCompeticaoAtletas)}
												{console.log('modalidades.current', modalidades.current)}
												{console.log('flag_atletas_por_pagar', flag_atletas_por_pagar)}
												{	
												estado_da_competicao_selecionada === true ?
													<div className="mb-3">
														<select
															className="form-select form-select-sm"
															value=""
															onChange={(e) => selecionar_atleta_competicao(e.target.value)}
														>
															<option value="">{language[lang].select ?? 'Selecione'}</option>
															{
															atletas_do_clube_disponiveis.map(a => {
																if(a?.info?.modalidades !== undefined && a.info.modalidades.some(p => (p?.value !== undefined ? modalidades_competicao_selecionada.includes(p.value) : (p?.id !== undefined ?  modalidades_competicao_selecionada.includes(p.id) : ''))))
																return (<option key={a.id} value={a.id}>{a.info?.name}</option>)
															})
															}
														</select>
													</div>
												:
													null
												}

											<div className="div-table">
												<table className="table table-bordered align-middle">
													<thead>
														<tr>
															<th className='p-3'>{language[lang].name ?? 'Atleta'}</th>
															<th className='p-3 text-center'>{language[lang].escalao ?? 'Escalão'}</th>
															<th className='p-3 text-center d-none'>{language[lang].modalidades ?? 'Modalidades'}</th>
															<th className='p-3 text-center'>{language[lang].state ?? 'Estado'}</th>
															<th></th>
														</tr>
													</thead>
													<tbody>
														{atletas_da_competicao_selecionada.length > 0 ? (
															atletas_da_competicao_selecionada.map((item , k) => (
																<tr key={`${item?.id ?? k}`}>
																	{console.log('item', item)}
																	<td className='p-3'>{item?.label ?? item?.name ?? '-'}</td>
																	<td className='p-3 text-center'>{item?.escalao ?? '-'}</td>
																	<td className='p-3 text-center d-none'>{language[lang][join_labels(item?.modalidades)]}</td>
																	<td className='p-3 text-center'>
																		{
																		item?.paid !== undefined && parseInt(item.paid) === 1 ?
																			<span className='badge bg-success p-1 fw-normal rounded-0'><i className="bi bi-check-lg text-white fs-4"></i></span>
																		:
																		item?.paid !== undefined && parseInt(item.paid) === 0 ?
																			<span className='badge bg-warning text-dark fs-6 fw-normal rounded-0'>{language[lang].pendente}</span>
																		: 
																			null
																		}
																	</td>
																	<td className="text-center">
																		{
																		estado_da_competicao_selecionada === true && (item?.paid === undefined || parseInt(item.paid) !== 1) ?
																			<button
																				type="button"
																				className="btn btn-sm btn-danger rounded-0"
																				title={language[lang].remove ?? 'Remover'}
																				onClick={() => remover_atleta_competicao(item?.id)}
																			>
																				<i className="bi bi-x-lg"></i>
																			</button>
																		:
																			null
																		}
																	</td>
																</tr>
															))
														) : (
															<tr>
																<td colSpan="5" className="text-center text-muted">
																	{language[lang].sem_registos ?? 'Sem registos'}
																</td>
															</tr>
														)}
													</tbody>
												</table>
											</div>
										</div>

										<div style={modalStyles.buttonContainer}>
											<button type="button" onClick={fecharAtletasCompeticaoModal}>
												{language[lang].cancel ?? 'Cancelar'}
											</button>
											{
											estado_da_competicao_selecionada === true && atletasPendentes.length > 0 ?
												<button
													type="button"
													className='btn btn-primary ms-2'
													style={{ opacity: atletasPendentes.length === 0 ? 0.6 : 1 }}
													disabled={atletasPendentes.length === 0}
													onClick={gravar_atletas_competicao}
												>
													{language[lang].update}
												</button>
											:
											flag_atletas_por_pagar ? 
												<button
													type="button"
													className='btn btn-success ms-2'
													onClick={pagar_atletas_competicao}
												>
													{language[lang].pay_athletes_registration_fee}
												</button>
											:
												null
											}
										</div>
									</div>
								</div>
							)}

							{showAssociarModal && (
								<div style={modalStyles.modalOverlay} onClick={handleCloseAssociarModal}>
									<div style={modalStyles.modalContent} onClick={(e) => e.stopPropagation()}>
										<div style={modalStyles.taskListContainer}>
											<label className="form-label fw-bold fs-6">{language[lang].pesquisar_entidade ?? 'Pesquisar'}</label>
											<input
												type="text"
												className="form-control mb-3"
												placeholder={language[lang].pesquisar_entidade_placeholder ?? 'Pesquisar por nome...'}
												value={associarSearch}
												onChange={handle_associar_search_change}
											/>

											<select
												className="form-select"
												size={8}
												value={selectedEntityToAssociate?.id ?? ''}
												onChange={(e) => {
													const found = associarResults.find(el => String(el.id) === String(e.target.value))
													setSelectedEntityToAssociate(found ?? null)
												}}
											>
												<option value="">
													{associarLoading ? (language[lang].loading ?? 'A carregar...') : (language[lang].field_choose ?? 'Selecione')}
												</option>
												{associarResults.map((el, k) => (
													<option key={el.id ?? k} value={el.id}>
														{(el.info?.name ?? el.name)}
													</option>
												))}
											</select>
										</div>

										<div style={modalStyles.buttonContainer}>
											<button type="button" onClick={handleCloseAssociarModal}>
												{language[lang].cancel ?? 'Cancelar'}
											</button>
											<button
												type="button"
												className='btn btn-primary ms-2'
												disabled={!selectedEntityToAssociate}
												onClick={() => associar_entidade_ao_clube(selectedEntityToAssociate)}
											>
												{language[lang].associar_confirm ?? 'Associar'}
											</button>
										</div>
									</div>
								</div>
							)}

							<button id={'btn_add_dirigente'} type="button" className="btn btn-sm btn-secondary rounded-0 me-2 d-none" data-bs-toggle="modal" data-bs-target={"#add_dirigente"}></button>
							<div className="modal bg-light fade" tabIndex="-1" id={"add_dirigente"}>
								<div className="modal-dialog modal-dialog-centered">
									<div className="modal-content">
										<div className="modal-header">
											<h5 className="modal-title">{language[lang].add_dirigente}</h5>

											<div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
												<i className="bi bi-x fs-2"></i>
											</div>
										</div>

										<div className="modal-body">
											{
											modal_add_dirigente_clube.current.name !== undefined ?
												<div className="row mb-3">
													<div className="col-12 col-sm-8">
														<label className="col-form-label fw-bold fs-6">{language[lang].field_name}</label>
														<input type="text" className="form-control mb-3" name="name" value={modal_add_dirigente_clube.current.name !== '' ? modal_add_dirigente_clube.current.name : ''} onChange={(e) => change_modal_dirigente_field(e)} placeholder={language[lang].name} /> 
													</div>
													<div className="col-12 col-sm-4">
														<label className="col-form-label fw-bold fs-6">{language[lang].field_position}</label>
														<input type="text" className="form-control mb-3" name="position" value={modal_add_dirigente_clube.current.position !== '' ? modal_add_dirigente_clube.current.position : ''} onChange={(e) => change_modal_dirigente_field(e)} placeholder={language[lang].position} /> 
													</div>
													<div className="col-12 col-sm-6">
														<label className="col-form-label fw-bold fs-6">{language[lang].field_email}</label>
														<input type="email" className="form-control mb-3" name="email" value={modal_add_dirigente_clube.current.email !== '' ? modal_add_dirigente_clube.current.email : ''} onChange={(e) => change_modal_dirigente_field(e)} placeholder={language[lang].email} /> 
													</div>
													<div className="col-12 col-sm-6">
														<label className="col-form-label fw-bold fs-6">{language[lang].field_phone}</label>
														<input type="text" className="form-control mb-3" name="mobile_phone" value={modal_add_dirigente_clube.current.mobile_phone !== '' ? modal_add_dirigente_clube.current.mobile_phone : ''} onChange={(e) => change_modal_dirigente_field(e)} placeholder={language[lang].phone} /> 
													</div>
												</div>
											:
												null
											}
										</div>

										<div className="modal-footer">
											<button type="button" className="btn btn-light d-none" data-bs-dismiss="modal">{language[lang].close}</button>
											<button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => save_modal_dirigente()}>{language[lang].save}</button>
										</div>
									</div>
								</div>
							</div>

							<button id={'btn_see_games'} type="button" className="btn btn-sm btn-secondary rounded-0 me-2 d-none" data-bs-toggle="modal" data-bs-target={"#see_games"}></button>
							<div className="modal bg-light fade" tabIndex="-1" id={"see_games"}>
								<div className="modal-dialog modal-xl modal-dialog-centered">
									<div className="modal-content">
										<div className="modal-header">
											<h5 className="modal-title">
												{language[lang].see_games}
												{
												competicao_el?.current?.id !== undefined ? 
													': ' + competicao_el.current.info.name 
												: 
													null}
											</h5>

											<div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
												<i className="bi bi-x fs-2"></i>
											</div>
										</div>

										{console.log('competicao_el.current', competicao_el.current)}
										{console.log('competicao_jogos.current', competicao_jogos.current)}
										<div className="modal-body">
											<div className="row mb-3">
												{
												Array.isArray(competicao_jogos.current) ?
													competicao_jogos.current.map((el_j, k_j) => {
														return (
															<div key={k_j} className="col-12 col-md-6 mb-3">
																{/* <!-- Início do Card do Jogo --> */}
																<div className="card shadow-sm text-center border-0 rounded-4">
																	{/* <!-- Cabeçalho: Nome do Torneio / Data --> */}
																	<div className="card-header bg-dark text-white rounded-top-4 py-2 small fw-bold text-uppercase tracking-wider">
																		{translate(el_j.info.name, 'pt')}
																	</div>
																	{/* <!-- Corpo do Card: Equipas e Resultado --> */}
																	<div className="card-body py-4">
																		<div className="row align-items-center">

																			{/* <!-- Equipa da Casa --> */}
																			<div className="col-4">
																				<img src={get_team_logo(el_j.info.equipa_casa.id)} alt={el_j.info.equipa_casa.label} className="img-fluid mb-2 rounded-circle bg-light p-2" />
																				<h6 className="card-title mb-0 text-truncate- fw-bold">{el_j.info.equipa_casa.label}</h6>
																			</div>
																			{/* <!-- Placar / Estado do Jogo --> */}
																			<div className="col-4 px-0">
																				<div className="d-flex flex-column align-items-center">
																					<span className="badge bg-danger text-uppercase fw-bold mb-2 animate-pulse small d-none">Ao Vivo</span>
																					<h2 className="fw-bolder mb-0 text-dark">{el_j?.info?.golos_periodo?.casa !== undefined ? soma_periodos(el_j.info.golos_periodo.casa) : ''} <i className="bi bi-x mx-1"></i> {el_j?.info?.golos_periodo?.visitante !== undefined ? soma_periodos(el_j.info.golos_periodo.visitante) : ''}</h2>
																					<small className="text-muted mt-1 fw-medium d-none">65'</small>

																					<small className="text-muted- mt-1 fw-medium mt-4">{el_j.info.data_jogo} {el_j.info.hora_inicio}</small>
																				</div>
																			</div>
																			{/* <!-- Equipa Visitante --> */}
																			<div className="col-4">
																				<img src={get_team_logo(el_j.info.equipa_visitante.id)} alt={el_j.info.equipa_visitante.label} className="img-fluid mb-2 rounded-circle bg-light p-2" />
																				<h6 className="card-title mb-0 text-truncate- fw-bold">{el_j.info.equipa_visitante.label}</h6>
																			</div>
																		</div>
																	</div>
																	{/* <!-- Rodapé: Detalhes Extra ou Botão de Bilhetes --> */}
																	<div className="card-footer bg-light border-top-0 rounded-bottom-4 py-3 d-none">
																		<div className="d-grid">
																		</div>
																	</div>
																</div>
																{/* <!-- Fim do Card --> */}
															</div>
														)
													})
												:
													null
												}
											</div>
										</div>

										<div className="modal-footer">
											<button type="button" className="btn btn-light d-none" data-bs-dismiss="modal">{language[lang].close}</button>
										</div>
									</div>
								</div>
							</div>		
						</div>


						{/*
						<div className="col-md-4 mb-5 mb-xl-10 d-none">
							<div className="card">
								<div className="card-header border-0" aria-expanded="true" aria-controls="kt_entidade_config">
									<div className="card-title m-0">
										<h3 className="fw-bolder m-0">{language[lang].config}</h3>
									</div>
								</div>
								<div id="kt_entidade_config" className="collapse show">
									<form id="form-config" onSubmit={handleSubmitConfig}>

										<div className="card-body border-top p-3">

											<div className="row mb-6">
												<label className="fs-6 fw-bold mb-2">{language[lang].language}</label>

												<select className="form-select mb-3 mb-lg-0 rounded-0" aria-label="Select Language" name='language' defaultValue={dados.current.info.language} onChange={handle_change_info}>
													<option value="pt">PT</option>
													<option value="en">EN</option>
												</select>
											</div>

											<div className="row mb-6">
												<label className="form-check form-switch form-check-custom form-check-solid pulse pulse-success" htmlFor="kt_user_menu_dark_mode_toggle">
													<input
														id={'dark-mode-switch'}
														name="darkmode"
														className="form-check-input w-45px h-30px"
														type="checkbox"
														onChange={handleSingleCheckDarkmode}
														defaultChecked={dados.current.info.darkmode}
													/>
													<span className="pulse-ring ms-n1"></span>
													<span className="form-check-label text-gray-600 fs-7">Dark Mode</span>
												</label>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
						*/}

						<button id={'btn_modal_payment_type'} type="button" className="btn btn-sm btn-secondary rounded-0 me-2 d-none" data-bs-toggle="modal" data-bs-target={"#modal_payment_type"}></button>
						<div className="modal bg-light fade" tabIndex="0" id={"modal_payment_type"} data-bs-backdrop="static" data-bs-keyboard="false" role="dialog">
							<div className="modal-dialog modal-dialog-centered">
								<div className="modal-content shadow-none">
									<div className="modal-header d-none">
										<h5 className="modal-title"></h5>

										<div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
											<i className="bi bi-x fs-2"></i>
										</div>
									</div>

									<div className="modal-body">
										<div className="pb-10">

											<div>
												<div className="my-3">
													<h3 className="titulo-primario">{language[lang].dados_tipo_pagamento}</h3>
													<p><strong>{language[lang].valor_a_pagar}:</strong> {nota_de_encomenda?.current?.info?.documento !== undefined ? parseFloat(nota_de_encomenda.current.info.documento.total_documento).toFixed(2).toString().replace('.', ',') : '0.00'}€</p>
												</div>

												<div className="row mb-3">
													<div className='col-12 mb-3'>
														<p>
															<strong>{language[lang].tb_iban}:</strong> {fdi_iban.current}
														</p>
														<p>
															<strong>{language[lang].tb_attention}:</strong> {language[lang].tb_details}
														</p>
													</div>
													
													<div className='col-6 col-sm-4 mx-auto'> 
														<button type='button' className='btn btn-outline-light shadow' onClick={() => set_paymet('tb', '2')}><img className='img-fluid' src={repo_img_link("transferencia.svg")} alt="tb" /></button>
													</div>
													<div className="mt-4">
														<small>
															* {language[lang].tb_click_image}
														</small>
													</div>

												</div>

												<div className="row mb-3 d-none">
													
													<div className='col-6 col-sm-4'> 
														<button type='button' className='btn btn-outline-light shadow' onClick={() => set_paymet('mbw', '-1')}><img className='img-fluid' src={repo_img_link("mbway-square.png")} alt="mbw" /></button>
													</div>
													<div className='col-6 col-sm-4'> 
														<button type='button' className='btn btn-outline-light shadow' onClick={() => set_paymet('mb', '1')}><img className='img-fluid' src={repo_img_link("mb-square.png")} alt="rm" /></button>
													</div>
													<div className='col-6 col-sm-4'> 
														<button type='button' className='btn btn-outline-light shadow' onClick={() => set_paymet('cc', '0')}><img className='img-fluid' src={repo_img_link("cc-square.png")} alt="cc" /></button>
													</div>

												</div>

											</div>

										</div>
									</div>

									<div className="modal-footer">
										<button type="button" className="btn btn-light" data-bs-dismiss="modal">
											{language[lang].cancel}
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className={'dash-cards footer'}>
				<nav className="navbar bottom-navbar navbar-light">
					<div className="navbar-footer">
						<ul className="navbar-nav float-left"></ul>
						<ul className="navbar-nav float-right">
							{getTokenInfo().profile === 'Administrador' || getTokenInfo().profile === 'Gestor de Conteúdos' ? (
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<i className="bi bi-chevron-left me-2"></i>
										<span>{language[lang].back}</span>
									</Link>
								</li>
							) : null}
							{getTokenInfo().profile === 'Administrador' ? (
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
							) : null}
							<li className="nav-item">
								<button type="submit" form="form" className="nav-link">
									<i className="bi bi-floppy me-2"></i>
									<span>{language[lang].save}</span>
								</button>
							</li>
						</ul>
					</div>
				</nav>
			</div>
		</main>
}

function ClubEntitiesTable({
	entities,
	language,
	lang,
	get_athlete_numero_federacao,
	get_entity_profile_labels,
	get_athlete_modalidades,
	get_entity_type_label,
	epoca_atual,
	highlightId,
	highlightLabel,
}) {
	return (
		<table className="table table-bordered align-middle">
			<thead>
				<tr>
					<th className='lh-lg p-3 text-nowrap'>{language[lang].numero_federacao ?? 'Nº Federação'}</th>
					<th className='lh-lg p-3 w-50'>{language[lang].name}</th>
					<th className='lh-lg p-3 text-center'>{language[lang].perfil ?? 'Perfil'}</th>
					<th className='lh-lg p-3 w-25 text-center'>{language[lang].modalidades ?? 'Modalidades'}</th>
					<th className='lh-lg p-3 text-center'>{language[lang].epoca ?? 'Época'}</th>
					{/* <th>{language[lang].tipo ?? 'Tipo'}</th> */}
				</tr>
			</thead>
			<tbody>
				{entities.length > 0 ? (
					entities.map((el, k) => (
						<tr key={el.id ?? k}>
							<td className='p-3 text-end'>{get_athlete_numero_federacao(el)}</td>
							<td className='p-3'>
								{el.info?.name}
								{highlightId && String(highlightId) === String(el.id) && (
									<span className="badge bg-warning text-dark ms-2">{highlightLabel}</span>
								)}
							</td>
							<td  className='p-3 text-center'>{get_entity_profile_labels(el) || '-'}</td>
							<td  className='p-3 text-center'>{get_athlete_modalidades(el) || '-'}</td>
							<td  className='p-3 text-center'>{epoca_atual.info.name}</td>
							{/* <td>
								<span className={`badge ${get_entity_type_label(el) === (language[lang].interna ?? 'Interna') ? 'bg-primary' : 'bg-secondary'}`}>
									{get_entity_type_label(el)}
								</span>
							</td> */}
						</tr>
					))
				) : (
					<tr>
						<td colSpan="6" className="text-center text-muted">
							{language[lang].sem_registos ?? 'Sem registos'}
						</td>
					</tr>
				)}
			</tbody>
		</table>
	);
}

function DocUploadField({ field, label, dados, language, lang, onChangeHandlerFilesDoc, handleDocRemove, edit_element_tree_doc, open_link, copy_clipboard }) {
	const current = dados?.current?.info?.[field];
	const hasFile = Array.isArray(current) && current.length > 0;
	const treeData = hasFile ? [{ id: `${field}-1`, title: current[0].name, link: current[0].link, visible: true }] : [];

	return (
		<div className="p-3 bg-white shadow-sm rounded h-100">
			<label className="form-label fw-bold fs-6 d-block">{label}</label>

			<div className="mb-2">
				<input
					type="file"
					accept="application/pdf"
					data-field={field}
					onChange={onChangeHandlerFilesDoc}
					className="d-none"
					id={`doc-upload-${field}`}
				/>
				<label htmlFor={`doc-upload-${field}`} className="btn btn-outline-primary btn-sm">
					{language[lang].doc_choose ?? 'Escolher ficheiro'}
				</label>
			</div>

			{hasFile ? (
				<SortableTree
					isVirtualized={false}
					treeData={treeData}
					maxDepth={1}
					scaffoldBlockPxWidth={0} // Remove a largura das linhas guias de estrutura
					canDrag={false}
					onChange={() => { }}
					getNodeKey={({ node }) => node.id}
					generateNodeProps={extendedNode => ({
						title: (
							<input
								type="text"
								className="form-control form-control-sm rounded-0"
								defaultValue={extendedNode.node.title}
								onBlur={(e) => edit_element_tree_doc(field, e)}
							/>
						),
						buttons: [
							<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
							<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
							<button type="button" onClick={() => handleDocRemove(field)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
						],
					})}
				/>
			) : (
				<div className="text-muted mb-2">{language[lang].noFile ?? 'Sem ficheiro'}</div>
			)}
		</div>
	);
}